import React, { useState, useEffect, useRef } from 'react'
import "./styleDashboard.css";
import Logo from "../../../assets/images/logo.png";
import profile from "../../../assets/images/profile.png";
import CalenderView from '../CalenderView/CalenderView';
import Notification from '../Notification/Notification';
import AddEmployeeHome from '../employee/AddEmployeeHome';
import NewAddTask from '../NewTask/NewAddTask'
import axios from 'axios';
import EditEmpInfo from '../employee/EditEmpInfo';
import Level from '../Level/Level';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import { debounce } from 'throttle-debounce';
import { Calendar } from 'primereact/calendar';
import 'react-date-range/dist/styles.css'; // main css file
import 'react-date-range/dist/theme/default.css'; // theme css file
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { Calendar as RouteCalender } from 'primereact/calendar';
import {
    setDataObject,
    setAddTask,
    setFullDate,
    setSelf,
    setDate,
    setReset,
    setEmpView,
    setHeader,
    setEditForm,
    setClosureMail,
    setRoute,
    setAddEmp,
    setEmpInfo,
    setAddProject,
    setNotifications,
    setRequestObject,
    setView,
    setProjectTaskFlow,
    setReminders,
    setLogout,
    setmtiID,
    setEditeKey,
    setAllEmployee,
    setSearchedMonth,
    setLevelSearch,
    setLoader,
    setStatusList,
    setPriorityList,
    setProjectListDay,
    setTagList,
    setAssigneeList,
    setVerfiedList,
    setUnRdNotiCount,
    setMonthData,
    setWeekData,
    setEmpLoadMore,
    setClosureProcedure,
    setAnalyticsData,
    setAnalyticsEmp,
    setAnalyticsEmpList,
    setIsDetailAnalytics,
    setAnalyticsStartDate,
    setAnalyticsEndDate,
    setLevelInfoObject,
    setRequestCount,
    setTaskEmp,
    setEmpJoiningDate,
    setInfoShow,
    setIanalyticsType,
    setanalyticsType,
    setLeaveCalenderViewFlag,
    setScannerViewFlag,
    setAttendenceMontViewFlag,
    setMyLeaveStatusFlag,
    setAttendMusteredFlag,
    setPrjAllTaskFlg,
    setIsHolidayStatus,
    setEmpLeaveStatus,
    setDispatchAllTask,

} from '../../../erpStore/actions';
import { Tree } from 'primereact/tree';
import Information from '../Information/Information';
import ClosureMail from '../ClosureMail/ClosureMail';
import EmployeeForm from '../employee/EmployeeForm';
import ProjectSection from '../Projects/ProjectSection';
import AddProject from '../Projects/project/AddProject';
import AddPhase from '../Projects/AddOperations/AddPhase';
import AddMilestone from '../Projects/AddOperations/AddMilestone';
import AddSprint from '../Projects/AddOperations/AddSprint';
import Request from '../Request/Request';
import LogsView from '../logs/LogsView';
import { useNavigate } from 'react-router-dom';
import ClosureReports from '../ClosureReports/ClosureReports';
import MeetingCards from '../Meetings/MeetingCards/MeetingCards';
import ProjectTasks from '../Projects/ProjectAllTaskView/ProjectTasks';
import Reminders from '../Reminders/Reminders';
import Logout from '../../pages/logout/Logout';
import { toast } from 'react-toastify';
import DenyPopUp from '../Request/DenyPopUp';
import DenyPreAskOptn from '../Request/DenyPreAskOptn';
import Setting from '../settings/Setting';
import ChangePass from '../settings/changepass/ChangePass';
import TaskDetails from '../Dayview/TaskDetails';
import MailKeyProcedure from '../ClosureMail/MailKeyProcedure';
import AnalyticsHome from '../analytics/AnalyticsHome';
import UpdateProject from '../Projects/project/UpdateProject';
import { type } from '@testing-library/user-event/dist/cjs/utility/type.js';
import LeveCalenderView from '../LeaveManagement/LeaveCalenderView/LeveCalenderView';
import AddHoliday from '../LeaveManagement/AddHoliday/AddHoliday';
import AddLeave from '../LeaveManagement/AddLeave/AddLeave';
import LeaveDayView from '../LeaveManagement/LeaveDayView/LeaveDayView';
import Scanner from '../Scanner/Scanner';
import AttendenceMonthView from '../Attendence/AttendenceMonthView/AttendenceMonthView';
import MyLeaveStatus from '../LeaveManagement/MyLeaveStatus/MyLeaveStatus';
import AttendenceDayView from '../Attendence/AttenceDayView/AttendenceDayView';
import AttendenceMustered from '../Attendence/AttendenceMustered/AttendenceMustered';
import EditeLeave from '../LeaveManagement/EditeLeave/EditeLeave';
import HolidayList from '../LeaveManagement/HolidayList/HolidayList';
import EditeHoliday from '../LeaveManagement/EditeHoliday/EditeHoliday';
import { filter } from 'lodash-es';
// import { onForegroundMessage } from '../../../firebase/FirebaseContactData';


function Dashboard() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const addProject = useSelector((state) => state.data.addProject)
    const apiUrl = useSelector((state) => state.data.apiUrl);
    const addTaskView = useSelector((state) => state.data.addTask);
    const view = useSelector((state) => state.data.view);
    const fullDateF = useSelector((state) => state.data.fullDate)
    const dataObjectInit = useSelector((state) => state.data.dataObject)
    const selfInfo = useSelector((state) => state.data.selfData)
    const closureMail = useSelector((state) => state.data.closureMail)
    const notifications = useSelector((state) => state.data.notifications)
    const reminderNotify = useSelector((state) => state.data.reminderNotify)
    const [routeS, setRouteS] = useState(window.sessionStorage.getItem("route") ? window.sessionStorage.getItem("route") : "mytask");
    const [selfData, setSelfData] = useState({})
    const [monthData] = useState({})
    const fdSplit = fullDateF.toString().split(", ")
    const [items, setitems] = useState();
    const [selectedNodeKey, setSelectedNodeKey] = useState('');
    const header = useSelector((state) => state.data.header);
    const editForm = useSelector((state) => state.data.editForm);
    const empForm = useSelector((state) => state.data.addEmp);
    const phaseView = useSelector((state) => state.data.addPhase);
    const getLogs = useSelector((state) => state.data.getLogs);
    const url = useSelector((state) => state.data.apiUrl)
    const self = useSelector((state) => state.data.selfData)
    const logout = useSelector((state) => state.data.logout)
    const empInfo = useSelector((state) => state.data.empInfo)
    const empUpdate = useSelector((state) => state.data.updateEmp)
    const reqDenyPopUp = useSelector((state) => state.data.reqDenyPopUp)
    const reAskOption = useSelector((state) => state.data.reAskOption)
    const searchedDate = useSelector((state) => state.data.searchedDate)
    const changePass = useSelector((state) => state.data.changePass)
    const [routeDate, setRouteDate] = useState("")
    const [analyticsMonth, setAnalyticsMonth] = useState();
    const [isDateRoute, setIsDateRoute] = useState(false)
    const dateRouteRef = useRef(null);
    const taskDetailFalg = useSelector((state) => state.data.taskDetailFalg)
    const closureProcedure = useSelector((state) => state.data.closureProcedure)
    const updateProjectFlag = useSelector((state) => state.data.updateProjectFlag)

    const [quaterYear, setQuaterYear] = useState(new Date().getFullYear());
    const [isQuaterYear, setIsQuaterYear] = useState(false)

    const projectAllTskVar = useSelector((state) => state.data.projectToUpadte)
    const projectAllTskFlag = useSelector((state) => state.data.projectAllTskFlag)
    const leaveCalenderViewFlag = useSelector((state) => state.data.leaveCalenderViewFlag)

    const addHolidayFlag = useSelector((state) => state.data.addHolidayFlag)
    const addLeaveFlag = useSelector((state) => state.data.addLeaveFlag)
    const scannerViewFlag = useSelector((state) => state.data.scannerViewFlag)
    const attendenceMonthViewFlag = useSelector((state) => state.data.attendenceMonthViewFlag)
    const myLeaveStatusFlag = useSelector((state) => state.data.myLeaveStatusFlag)
    const attendenceMusteredFlag = useSelector((state) => state.data.attendenceMusteredFlag)
    const editeLeaveFlag = useSelector((state) => state.data.editeLeaveFlag)
    const holidayListFlag = useSelector((state) => state.data.holidayListFlag)

    const editeHolidayFlag = useSelector((state) => state.data.editeHolidayFlag)

    const isHolidayStatus = useSelector((state) => state.data.isHolidayStatus)
    const empIsLeaveStatus = useSelector((state) => state.data.empIsLeaveStatus)
    
    const isPresent = useSelector((state) => state.data.isPresentDay)
    const dispatchAllTask = useSelector((state) => state.data.dispatchAllTask)
    

    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);

    const covertStringFormat = (stringFormat) => {
        return stringFormat === 'FULLDAY' ? 'Full Day Leave' : stringFormat === 'HALFDAY1' ? 'First Half Leave' : 'Second Half Leave'
    }

    useEffect(() => {
        setStartDate(null)
        setEndDate(null)
        if((routeS === 'mytask' && view !== 'day') || (routeS === 'level' &&  view !== 'day' )){
            dispatch(setIsHolidayStatus(null))
            dispatch(setEmpLeaveStatus(null))
        }
    }, [routeS, view])

    const onSelect = (event) => {
        dispatch(setView('level'))

        if(routeS !== 'level'){
            const weekdays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
        const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

        // Get the day of the week, date, month, and year
        const dayOfWeek = weekdays[new Date().getDay()];
        const day = new Date().getDate();
        const month = months[new Date().getMonth()];
        const year = new Date().getFullYear();

        // Format the date string
        const formattedDate = `${dayOfWeek}, ${day} ${month} ${year}`;
        dispatch(setFullDate(formattedDate))
        }

        dispatch(setLevelInfoObject(event.node.label))
        window.sessionStorage.setItem('levelVal', event.node.label)
        window.sessionStorage.setItem('route', 'level')
        setRouteS("level")
        window.sessionStorage.setItem("route", "level")
        window.sessionStorage.setItem("view", "level")
        dispatch(setRoute("level"))
        dispatch(setEmpView(false))
        dispatch(setHeader(event.node.label))
        window.sessionStorage.setItem('header', event.node.label)
        setSelectedNodeKey(event.node.key)
        dispatch(setmtiID(false))
    };


    useEffect(() => {
        const stringHeaders = window.localStorage.getItem('myHeaders');
        const storedHeaders = JSON.parse(stringHeaders);

        if (!storedHeaders || !storedHeaders.Authorization) {
            navigate('/login')
            return
        }
        if (!window.sessionStorage.getItem("route")) {
            window.sessionStorage.setItem("route", "mytask")
        }
        if (!window.sessionStorage.getItem("view")) {
            dispatch(setView("month"))
            window.sessionStorage.setItem("view", "month")
        }
        dispatch(setHeader(window.sessionStorage.getItem('header')))

        const url = apiUrl + 'employee/single';
        const currentDate = moment(fdSplit[1]);
        window.sessionStorage.setItem("date", currentDate.format('dddd') + ", " + currentDate.date() + " " + currentDate.format('MMM') + " " + currentDate.year())
        dispatch(setFullDate(currentDate.format('dddd') + ", " + currentDate.date().toString().padStart(2, '0') + " " + currentDate.format('MMM') + " " + currentDate.year()))
        const requestData = {
            userId: window.localStorage.getItem('userId')
        };
        axios.post(url, requestData, {
            headers: storedHeaders,
        })
            .then(response => {
                setSelfData(response.data);
                dispatch(setSelf(response.data))
                const headersString = JSON.stringify(response.data);
                window.localStorage.setItem("selfInfo",headersString)
                if (routeS === "mytask") {
                    dispatch(setEmpInfo(response.data))
                    dispatch(setTaskEmp(response.data))
                }
                window.localStorage.setItem('id', response.data.empId)
                if (window.sessionStorage.getItem("view")) {
                    dispatch(setView(window.sessionStorage.getItem("view")))
                }
                if (!window.sessionStorage.getItem('levelVal') || window.sessionStorage.getItem('levelVal') === "1") {
                    window.sessionStorage.setItem('levelVal', response.data.role[0].roleName)
                }

            })
            .catch(error => {
                if (error.message === "Network Error") {
                    navigate('/net-error')
                } else if (error.response && error.response.status === 401) {
                    navigate("/login")
                }
            });
    }, [empUpdate])
    // useEffect(() => {
    //     onForegroundMessage()
    //         .then((payload) => {
    //             /* This line of code is using object destructuring in JavaScript to extract the title and
    //             body properties from the notification object nested within the payload.data object. */
    //             // const { notification: { title, body } } = payload.data;
    //         })
    //         .catch(err => {});
    // }, [onForegroundMessage]);
    useEffect(() => {
        const handlePopState = () => {
            // Redirect user to a specific page
            window.location.href = '/';
        };

        window.addEventListener('popstate', handlePopState);

        return () => {
            window.removeEventListener('popstate', handlePopState);
        };
    }, []);


    //@@Govind Dindewad
    //to restore a pages on refresh at level view
    useState(() => {
        const levelVal = window.sessionStorage.getItem('levelVal')
        const view = window.sessionStorage.getItem('view')

        if (routeS === 'level' && view === 'day') {
            window.sessionStorage.setItem('header', levelVal)
            dispatch(setHeader(levelVal))
            dispatch(setView('level'))
            window.sessionStorage.setItem('view', 'level')

        }
    }, [])
    useEffect(() => {
        function handleOutsideClick(event) {
            if (dateRouteRef && dateRouteRef.current && !dateRouteRef.current.contains(event.target)) {
                setIsDateRoute(false)
            }
        }
        document.addEventListener("mousedown", handleOutsideClick);
        return () => {
            document.removeEventListener("mousedown", handleOutsideClick)
        }
    }, [])

    const getAllLists = () => {

        const stringHeaders = window.localStorage.getItem('myHeaders');
        const storedHeaders = JSON.parse(stringHeaders);

        axios.get(`${url}task/status/get/all`, { headers: storedHeaders, })
            .then(response => {
                if (response.request.status === 200) {
                    dispatch(setStatusList(response.data))

                }
            })
            .catch(err => {
                if (err.response && err.response.status === 500) {
                    navigate("/server-error")
                }
            })

        axios.get(`${url}task/priority/get/all`, { headers: storedHeaders })
            .then(response => {
                if (response.request.status === 200) {
                    dispatch(setPriorityList(response.data))
                }
            })
            .catch(err => {
                if (err.response && err.response.status === 500) {
                    navigate("/server-error")
                }
            })

        axios.post(`${url}project/get/all/for-employee`, { "userId": selfInfo?.userId }, { headers: storedHeaders })
        .then(response => {
          if (response.request.status === 200) {
            dispatch(setProjectListDay(response.data))
          }
        })
        .catch(error => {
          if (error.response && error.response.status === 500) {
            navigate("/server-error")
          }
        })

        axios.get(`${url}task/verification/get/all`, { headers: storedHeaders })
            .then(response => {
                if (response.request.status === 200) {
                    dispatch(setVerfiedList(response.data))
                }
            })
            .catch(err => {
                if (err.response && err.response.status === 500) {
                    navigate("/server-error")
                }
            })

    }

    useEffect(() => {
        getAllLists()
    }, [])

    useEffect(() => {
        const stringHeaders = window.localStorage.getItem('myHeaders');
        const storedHeaders = JSON.parse(stringHeaders);
        axios.get(`${url}employee/department/get/all`, { headers: storedHeaders })
            .then(response => {
                if (response.request.status === 200) {
                    dispatch(setTagList(response.data))
                }
            })
            .catch(err => {
                if (err.response && err.response.status === 500) {
                    navigate("/server-error")
                }
            })
    }, [])

    const buildLabelStructure = (roles) => {
        const items = [];
        const levels = new Map();
        if (selfInfo.role && selfInfo.role.length > 0) {
            let val = true
            roles.forEach((role) => {
                if (val) {
                    val = !(role.roleName === window.sessionStorage.getItem('levelVal'))
                }

                const newItem = {
                    key: `${role.roleLevel}-${role.roleId}`,
                    label: role.roleName,
                    expanded: val,
                    children: [],
                };

                if (role.roleLevel === selfInfo.role[0].roleLevel) {
                    items.push(newItem);
                    levels.set(selfInfo.role[0].roleLevel, newItem.children);
                } else {
                    const parentLevel = role.roleLevel - 1;
                    const parentItems = levels.get(parentLevel);

                    if (parentItems) {
                        parentItems.push(newItem);
                        if (!levels.has(role.roleLevel)) {
                            levels.set(role.roleLevel, newItem.children);
                        }
                    }
                }
            }
            );
        }
        return items;
    };


    const [roles, setLevelData] = useState()
    useEffect(() => {
        setSelfData(selfInfo)
    }, [selfInfo])
    const fetchLevelData = () => {
        const stringHeaders = window.localStorage.getItem('myHeaders');
        const storedHeaders = JSON.parse(stringHeaders);
        if (selfInfo.role && selfInfo.role.length > 0) {
            axios.get(`${apiUrl}employee/role/level/${selfInfo.role[0].roleLevel}`, {
                headers: storedHeaders,
            })
                .then(response => {
                    setLevelData(response.data)
                    setitems(buildLabelStructure(response.data))
                })
                .catch(error => {
                    if (error.response && error.response.status === 500) {
                        navigate("/server-error")
                    }
                })

        }
    }

    useEffect(() => {
        fetchLevelData()
    }, [selfInfo.role])


    useEffect(() => {
        const stringHeaders = window.localStorage.getItem('myHeaders');
        const storedHeaders = JSON.parse(stringHeaders);
        if (self && self.role && self.role.length > 0) {
            axios.post(`${url}employee/get/assignee`, { 'roleLevel': self.role[0].roleLevel }, { headers: storedHeaders })
                .then(response => {
                    if (response.request.status === 200) {
                        dispatch(setAssigneeList(response.data))
                    }
                })
                .catch(error => {

                    if (error.response && error.response.status === 500) {
                        navigate("/server-error")
                    }

                });
        }


    }, [selfInfo])

    const notifactionCont = useSelector((state) => state.data.unRdNotiCount)

    const pendingReq = useSelector((state) => state.data.reqCount);
    useEffect(() => {
        const stringHeaders = window.localStorage.getItem('myHeaders');
        const storedHeaders = JSON.parse(stringHeaders);
        var userId = window.localStorage.getItem('userId');
        const fetchCount = async () => {
            try {
                axios.get(`${apiUrl}notification/logs/get/unread-count?userId=${userId}`, { headers: storedHeaders })
                    .then(response => {
                        if (response.request.status === 200) {
                            dispatch(setUnRdNotiCount(response.data.notificationUnreadCount))
                        }
                    })
                    .catch(error => { })

            } catch (err) {

                if (err.response && err.response.status === 500) {
                    navigate("/server-error")
                }

            } 
            try {
                const response = await axios.get(`${apiUrl}task/pending-req`, {
                    headers: storedHeaders
                })
                if (response && response.data) {
                    dispatch(setRequestCount(response.data))
                } else {
                    if (response.data === 0) {
                        dispatch(setRequestCount(response.data))
                    }
                }

            } catch (err) {

                if (err.response && err.response.status === 500) {
                    navigate("/server-error")
                }

            }

        }
        if (self.userId && (routeS === 'request')) {
            fetchCount();
        }

    }, [routeS, view, self, notifications])


    useEffect(() => {
        const stringHeaders = window.localStorage.getItem('myHeaders');
        const storedHeaders = JSON.parse(stringHeaders);
        const fetchCount = async () => {
            try {
                const response = await axios.get(`${apiUrl}notification/logs/get/unread-count?userId=${self.userId}`, {
                    headers: storedHeaders
                })
                if (response && response.data) {
                    dispatch(setUnRdNotiCount(response.data.notificationUnreadCount))
                }
            } catch (err) {

                if (err.response && err.response.status === 500) {
                    navigate("/server-error")
                }

            } 
            try {
                const response = await axios.get(`${apiUrl}task/pending-req`, {
                    headers: storedHeaders
                })
                if (response && response.data) {
                    dispatch(setRequestCount(response.data))
                } else {
                    if (response.data === 0) {
                        dispatch(setRequestCount(response.data))
                    }
                }

            } catch (err) {

                if (err.response && err.response.status === 500) {
                    navigate("/server-error")
                }

            }

        }
        fetchCount();

    }, [])
    const handleRoute = (e) => {
        if (e === 'mytask') {
            setRouteS("mytask")
            window.sessionStorage.setItem("route", "mytask")
            dispatch(setRoute("mytask"))
        } else if (e === "employee") {
            setRouteS("employee")
            window.sessionStorage.setItem("route", "employee")
            dispatch(setRoute("employee"))
        } else if (e === "info") {
            setRouteS("info")
            window.sessionStorage.setItem("route", "info")
            dispatch(setRoute("info"))
        } else if (e === 'projects') {
            setRouteS("projects")
            window.sessionStorage.setItem("route", "projects")
            dispatch(setRoute("projects"))
        } else if (e === 'requests') {
            setRouteS('requests')
            window.sessionStorage.setItem("route", "requests")
            dispatch(setRoute('requests'))
        } else if (e === 'notifications') {
            setRouteS('notifications')
            window.sessionStorage.setItem("route", "notifications")
            dispatch(setRoute('notifications'))
        } else if (e === 'closureReport') {
            setRouteS('closureReport')
            window.sessionStorage.setItem("route", "closureReport")
            dispatch(setRoute('closureReport'))
        } else if (e === 'meettingsCards') {
            setRouteS('meettingsCards')
            window.sessionStorage.setItem("route", "meettingsCards")
            dispatch(setRoute('meettingsCards'))
        } else if (e === 'analytics') {
            setRouteS('analytics')
            window.sessionStorage.setItem("route", "analytics")
            dispatch(setAnalyticsEmp(selfData.userId))
            dispatch(setRoute('analytics'))
        } else if (e === 'settings') {
            setRouteS('settings')
            window.sessionStorage.setItem("route", "settings")
            dispatch(setRoute('settings'))
        }
    }

    //@@Auther Govind Dindewad
    //for the all employee list called onlyb once with pagination
    const handleEmployeeList = () => {

    }


    const handlePrevDate = () => {
        const currentDate = moment(fdSplit[1]);
        dispatch(setLoader(true))
        const previousDate = currentDate.subtract(1, 'day');
        dispatch(setFullDate(previousDate.format('dddd') + ", " + previousDate.date().toString().padStart(2, "0") + " " + previousDate.format('MMM') + " " + previousDate.year()))
        window.sessionStorage.setItem('date', previousDate.format('dddd') + ", " + previousDate.date().toString().padStart(2, "0") + " " + previousDate.format('MMM') + " " + previousDate.year())
        setRouteDate(previousDate._d)
    }
    const handleNextDate = () => {
        const currentDate = moment(fdSplit[1]);
        dispatch(setLoader(true))
        const nextDate = currentDate.add(1, 'day')
        dispatch(setFullDate(nextDate.format('dddd') + ", " + nextDate.date().toString().padStart(2, "0") + " " + nextDate.format('MMM') + " " + nextDate.year()))
        window.sessionStorage.setItem('date', nextDate.format('dddd') + ", " + nextDate.date().toString().padStart(2, "0") + " " + nextDate.format('MMM') + " " + nextDate.year())
        setRouteDate(nextDate._d)
    }

    const editFrom = () => {
        dispatch(setEditForm(true))
        dispatch(setEmpInfo(selfData))
    }

    const handleSort = (e, dataObjectForSearch = null) => {
        if (dataObjectInit && e !== 5 && e !== 4) {
            dispatch(setDataObject(dataObjectInit, e))
            dispatch(setReset(0))
        }

        if (e === 5) {
            dispatch(setDataObject(dataObjectForSearch, e))
            dispatch(setReset(0))
        }
    }

    const getMonthNumber = (monthName) => {
        if(monthName){
        const monthMoment = moment().month(monthName).startOf('month');
        return monthMoment.format('MM');
        }
    };


    //search function for day view for search task in day
    const handleSearchTasks = (e) => {
        const splitFullDate = fullDateF.split(" ")
        const mNumber = getMonthNumber(splitFullDate[2])
        const postDate = splitFullDate[3] + "-" + (mNumber.length > 1 ? mNumber : '0' + mNumber) + "-" + splitFullDate[1]
        const stringHeaders = window.localStorage.getItem('myHeaders');
        const storedHeaders = JSON.parse(stringHeaders);
        const serachTaskUrl = `${apiUrl}task/search`

        // if (view === 'month') {
        //     axios.post(serachTaskUrl, { "key": e.target.value, "empId": parseInt(selfInfo.empId), }, { headers: storedHeaders }, {
        //         headers: storedHeaders,
        //     })
        //         .then((response) => {

        //         })
        //         .catch((error) => {})
        // } else if (view === 'week') {

        //     axios.post(serachTaskUrl, { "key": e.target.value, "empId": parseInt(selfInfo.empId), "date": postDate }, { headers: storedHeaders })
        //         .then(response => {
        //             handleSort(7, response)
        //         })
        //         .catch(err => {
        //         })
        // } else {

        axios.post(serachTaskUrl, { "key": e, "empId": parseInt(routeS === "mytask" ? selfInfo.empId : empInfo.empId), "date": postDate }, { headers: storedHeaders })
            .then(response => {
                    handleSort(5, response.data.task)
                dispatch(setDispatchAllTask(response.data.task))
            })
            .catch(err => {
               
            })

    }
    const [searchValue, setSearchValue] = useState()
    const handleSearches = (e) => {
        setSearchValue(e.target.value)
        const stringHeaders = window.localStorage.getItem('myHeaders');
        const storedHeaders = JSON.parse(stringHeaders);
        const dateSplit = searchedDate.toString().length < 17 ? searchedDate.split("-") : searchedDate.toString().split(" ")
        if (routeS === 'employee') {
            axios.get(`${apiUrl}employee/search?key=${e.target.value}`, {
                headers: storedHeaders
            })
                .then((res) => {
                    if (res.status === 200) {
                        dispatch(setAllEmployee(res.data))
                    }
                })
                .catch((err) => {
                   

                    if (err.response && err.response.status === 500) {
                        navigate("/server-error")
                    }

                })
            return

        } else if (routeS === 'mytask') {
            if (view === 'month') {

                axios.post(`${apiUrl}task/search`, {
                    key: searchValue,
                    empId: self.empId,
                    year: parseInt(dateSplit[0]),
                    month: parseInt(dateSplit[1])
                }, {
                    headers: storedHeaders
                })
                    .then((response) => {
                        if (response.status === 200) {
                            dispatch(setMonthData(response.data))
                        }

                    })
                    .catch((error) => {
                        if (error.response && error.response.status === 500) {
                            navigate("/server-error")
                        }
                    })
            }
        } else if (routeS === 'level') {
            const splitDate = fullDateF.split(", ")[1].split(" ")
            const formattedDate = splitDate[2] + "-" + getMonthNumber(splitDate[1]) + "-" + splitDate[0]
            if (view === 'level') {
                if (e.target.value.length > 2) {
                    axios.post(`${apiUrl}employee/level/search/get`, {
                        key: e.target.value,
                        date: formattedDate,
                        role: window.sessionStorage.getItem('header')
                    }, {
                        headers: storedHeaders
                    })
                        .then((res) => {
                            if (res.status === 200) {
                                dispatch(setLevelSearch(res.data))
                            }
                        })
                        .catch((err) => {
                            if (err.response && err.response.status === 500) {
                                navigate("/server-error")
                            }
                        })
                } else {
                    dispatch(setLevelSearch([]))
                }
            }
        }

    }

    const handleSearchMonth = async (e) => {
        const stringHeaders = window.localStorage.getItem('myHeaders');
        const storedHeaders = JSON.parse(stringHeaders);
        const dateSplit = searchedDate.toString().length < 17 ? searchedDate.split("-") : searchedDate.toString().split(" ")
        if (routeS === 'level') {
            try {
                const response = await axios.post(`${apiUrl}task/employee/get/by/month-search`, {
                    key: e,
                    userId: empInfo && empInfo.length > 0 ? empInfo.userId : empInfo.userId,
                    year: parseInt(dateSplit[0]),
                    month: parseInt(dateSplit[1])
                }, {
                    headers: storedHeaders
                })
                if (response && response.data) {
                    dispatch(setMonthData(response.data))
                }

            } catch (error) {
                if (error.response && error.response.status === 500) {
                    navigate("/server-error")
                }
            }
        } else {


            try {
                const response = await axios.post(`${apiUrl}task/search`, {
                    key: e,
                    empId: empInfo && empInfo.length > 0 && routeS !== 'mytask' ? empInfo.empId : selfInfo.empId,
                    year: parseInt(dateSplit[0]),
                    month: parseInt(dateSplit[1])
                }, {
                    headers: storedHeaders
                })
                if (response && response.data) {
                    dispatch(setMonthData(response.data))
                }

            } catch (error) {
                if (error.response && error.response.status === 500) {
                    navigate("/server-error")
                }
            }
        }
    }

    const handleSearchweek = async (e) => {
        const stringHeaders = window.localStorage.getItem('myHeaders');
        const storedHeaders = JSON.parse(stringHeaders);
        const dateSplit = searchedDate.toString().length < 17 ? searchedDate.split("-") : searchedDate.toString().split(" ")
        const date = new Date(dateSplit)
        const weekNo = moment(searchedDate.toString().length < 17 ? searchedDate.split("-") : searchedDate.toString().split(" ")).isoWeek()
        try {
            const response = await axios.post(`${apiUrl}task/search`, {
                key: e,
                empId: routeS === "mytask" ? selfInfo.empId : empInfo.empId,
                year: parseInt(dateSplit[0]),
                month: 1,
                weekNumber: moment(date).isoWeek()
            }, {
                headers: storedHeaders
            })
            if (response && response.data) {
                dispatch(setWeekData(response.data))
            }

        } catch (error) {
            if (error.response && error.response.status === 500) {
                navigate("/server-error")
            }
        }
    }
    const handleSearchlevel = async (e) => {
        const stringHeaders = window.localStorage.getItem('myHeaders');
        const storedHeaders = JSON.parse(stringHeaders);
        const splitDate = fullDateF.split(", ")[1].split(" ")
        const formattedDate = splitDate[2] + "-" + getMonthNumber(splitDate[1]) + "-" + splitDate[0]
        try {
            const response = await axios.post(`${apiUrl}employee/level/search/get`, {
                key: e,
                date: formattedDate,
                role: window.sessionStorage.getItem('header')
            }, {
                headers: storedHeaders
            })
            if (response && response.data.data) {
                dispatch(setLevelSearch(response.data.data))
            }

        } catch (err) {

            if (err.response && err.response.status === 500) {
                navigate("/server-error")
            }

        }
    }

    const handleSearchEmployee = (e) => {

        const stringHeaders = window.localStorage.getItem('myHeaders');
        const storedHeaders = JSON.parse(stringHeaders);
        axios.get(`${apiUrl}employee/get/all?page=0&size=20&key=${e}`, {
            headers: storedHeaders
        })
            .then((res) => {
                if (res.status === 200) {
                    if (e !== "") {
                        dispatch(setAllEmployee(res.data))
                        dispatch(setEmpLoadMore(true));
                    } else {
                        dispatch(setAllEmployee(res.data.data))
                        dispatch(setEmpLoadMore(res.data.isLastPage))
                    }

                }
            })
            .catch((err) => {
                if (err.response && err.response.status === 500) {
                    navigate("/server-error")
                }
            })
        return
    }
    const debouncedSearchLevel = debounce(1000, handleSearchlevel);
    const debouncedSearchMonth = debounce(1000, handleSearchMonth);
    const debouncedSearchWeek = debounce(1000, handleSearchweek);
    const debouncedSearchDay = debounce(1000, handleSearchTasks);
    const debouncedSearchEmployee = debounce(1000, handleSearchEmployee);

    function formatNumberCount(number) {
        const absNumber = Math.abs(number);
        const billion = 1000000000;
        const million = 1000000;
        const thousand = 1000;

        if (absNumber >= billion) {
            return (number / billion).toFixed(1).replace(/\.0$/, '') + 'b';
        }
        if (absNumber >= million) {
            return (number / million).toFixed(1).replace(/\.0$/, '') + 'm';
        }
        if (absNumber >= thousand) {
            return (number / thousand).toFixed(1).replace(/\.0$/, '') + 'k';
        }
        return number.toString();
    }

    const handleRouteDate = (e) => {
        const currentDate = moment(e.target.value);
        const previousDate = currentDate.subtract(0, 'day');
        dispatch(setFullDate(previousDate.format('dddd') + ", " + previousDate.date().toString().padStart(2, "0") + " " + previousDate.format('MMM') + " " + previousDate.year()))
        window.sessionStorage.setItem('date', previousDate.format('dddd') + ", " + previousDate.date().toString().padStart(2, "0") + " " + previousDate.format('MMM') + " " + previousDate.year())
        setIsDateRoute(false)
        setRouteDate(previousDate.format('dddd') + ", " + previousDate.date().toString().padStart(2, "0") + " " + previousDate.format('MMM') + " " + previousDate.year())
    }

    const [isMonthAnalytics, setIsMonthAnalytics] = useState(false)
    const [isYearAnalytics, setIsYearAnalytics] = useState(false)
    const yearDateRouteWrapper = useRef(null)
    const mothDateRouteWrapper = useRef(null)
    const [selectedBtn, setSelectedBtn] = useState('year')
    useEffect(() => {
        function handleOutsideClick(event) {
            if (mothDateRouteWrapper && mothDateRouteWrapper.current && !mothDateRouteWrapper.current.contains(event.target)) {
                setIsMonthAnalytics(false)
            } else if (yearDateRouteWrapper && yearDateRouteWrapper.current && !yearDateRouteWrapper.current.contains(event.target)) {
                setIsYearAnalytics(false)
            }
        }
        document.addEventListener("mousedown", handleOutsideClick);
        return () => {
            document.removeEventListener("mousedown", handleOutsideClick)
        }
    }, [])
    const [isQuaterAnylytics, setIsQuarterAnalytics] = useState(false)
    const quaterRouteRef = useRef(null)
    useEffect(() => {
        function handleOutsideClick(event) {
            if (quaterRouteRef && quaterRouteRef.current && !quaterRouteRef.current.contains(event.target)) {
                setIsQuarterAnalytics(false)
            }
        }
        document.addEventListener("mousedown", handleOutsideClick);
        return () => {
            document.removeEventListener("mousedown", handleOutsideClick)
        }
    }, [])

    const [monthBtn, setMonthBtn] = useState("Month")
    const isDetailAnalytics = useSelector((state) => state.data.isDetailAnalytics)
    const analyticsEmp = useSelector((state) => state.data.analyticsEmp)
    const handleMonthAnalytics = async (e) => {
        setIsMonthAnalytics(false)
        setSelectedQuarter('Quarter')
        setYearBtn('Year')
        setSelectedBtn('month')
        setStartDate("")
        setEndDate("")
        const stringHeaders = window.localStorage.getItem('myHeaders');
        const storedHeaders = JSON.parse(stringHeaders);
        const date = new Date(e.target.value)
        const dateSplit = date.toString().split(" ")
        setMonthBtn(dateSplit[1] + "-" + dateSplit[3])
        const year = date.getFullYear();
        const month = date.getMonth();

        const splitDate = new Date(year, month + 1, 0).toString().split(" ");

        // Create a new Date object for the first day of the month
        // Format the first and last date of the month
        const firstDateFormatted = splitDate[3] + "-" + getMonthNumber(splitDate[1]) + "-" + "01";
        const lastDateFormatted = splitDate[3] + "-" + getMonthNumber(splitDate[1]) + "-" + splitDate[2]
        dispatch(setAnalyticsStartDate(firstDateFormatted))
        dispatch(setAnalyticsEndDate(lastDateFormatted))
        dispatch(setanalyticsType('month'))
        try {
            const resp = await axios.post(`${apiUrl}emp/analytics/get-single`, {
                userId: analyticsEmp,
                startDate: firstDateFormatted,
                endDate: lastDateFormatted,
                type: 'month'
            }, {
                headers: storedHeaders
            })
            if (resp && resp.data) {
                dispatch(setAnalyticsData(resp.data))
            }
        } catch (err) {
            if (err.response && err.response.status === 500) {
                navigate("/server-error")
            }
           
        }
        if (isDetailAnalytics === true) {
            try {
                dispatch(setAnalyticsEmpList([]))
                const resp = await axios.post(`${apiUrl}emp/analytics/get-assignee-list`, {
                    roleLevel: selfData && selfData.role && selfData.role.length > 0 ? selfData.role[0].roleLevel : 0,
                    startDate: firstDateFormatted,
                    endDate: lastDateFormatted,
                    key: '',
                    type: 'month'
                }, {
                    headers: storedHeaders
                })
                if (resp && resp.data) {
                    dispatch(setAnalyticsEmpList(resp.data))
                }
            } catch (err) {
                if (err.response && err.response.status === 500) {
                    navigate("/server-error")
                }
               
            }
        }
    }


    const handleRangeAnalytics = async (start, end) => {
        setIsMonthAnalytics(false)
        setSelectedQuarter('Quarter')
        setYearBtn('Year')
        const stringHeaders = window.localStorage.getItem('myHeaders');
        const storedHeaders = JSON.parse(stringHeaders);
        const startDate = moment(start).format('YYYY-MM-DD')
        const endDate = moment(end).format('YYYY-MM-DD')
        dispatch(setanalyticsType('range'))
        if (start && end) {
            setSelectedBtn('range')
            dispatch(setAnalyticsStartDate(startDate))
            dispatch(setAnalyticsEndDate(endDate))
            try {
                const resp = await axios.post(`${apiUrl}emp/analytics/get-single`, {
                    userId: analyticsEmp,
                    startDate: startDate,
                    endDate: endDate,
                    type: 'range'
                }, {
                    headers: storedHeaders
                })
                if (resp && resp.data) {
                    dispatch(setAnalyticsData(resp.data))
                }
            } catch (err) {
                if (err.response && err.response.status === 500) {
                    navigate("/server-error")
                }
               
            }
            if (isDetailAnalytics === true) {
                try {
                    const resp = await axios.post(`${apiUrl}emp/analytics/get-assignee-list`, {
                        roleLevel: selfData && selfData.role && selfData.role.length > 0 ? selfData.role[0].roleLevel : 0,
                        startDate: startDate,
                        endDate: endDate,
                        key: '',
                        type: 'range'
                    }, {
                        headers: storedHeaders
                    })
                    if (resp && resp.data) {
                        dispatch(setAnalyticsEmpList(resp.data))
                    }
                } catch (err) {
                    if (err.response && err.response.status === 500) {
                        navigate("/server-error")
                    }
                   
                }
            }
        }

    }

    // }
    const [selectedQuarter, setSelectedQuarter] = useState('Quarter')
    const handleQuarterData = async (start, end, quarter) => {
        setIsQuarterAnalytics(false)
        setSelectedQuarter(quarter)
        setMonthBtn('Month')
        setYearBtn('Year')
        setSelectedBtn('quarter')
        setStartDate("")
        setEndDate("")
        dispatch(setanalyticsType('quarter'))
        const stringHeaders = window.localStorage.getItem('myHeaders');
        const storedHeaders = JSON.parse(stringHeaders);

        try {
            const resp = await axios.post(`${apiUrl}emp/analytics/get-single`, {
                userId: analyticsEmp,
                startDate: start,
                endDate: end,
                type: 'quarter'
            }, {
                headers: storedHeaders
            })
            if (resp && resp.data) {
                dispatch(setAnalyticsData(resp.data))
            }
        } catch (err) {
            if (err.response && err.response.status === 500) {
                navigate("/server-error")
            }
           
        }
        if (isDetailAnalytics === true) {
            try {
                const resp = await axios.post(`${apiUrl}emp/analytics/get-assignee-list`, {
                    roleLevel: selfData && selfData.role && selfData.role.length > 0 ? selfData.role[0].roleLevel : 0,
                    startDate: start,
                    endDate: end,
                    key: '',
                    type: 'quarter'
                }, {
                    headers: storedHeaders
                })
                if (resp && resp.data) {
                    dispatch(setAnalyticsEmpList(resp.data))
                }
            } catch (err) {
                if (err.response && err.response.status === 500) {
                    navigate("/server-error")
                }
               
            }
        }

    }
    const [yearBtn, setYearBtn] = useState(new Date().getFullYear())
    const handleYearAnalytics = async (e) => {
        setIsYearAnalytics(false)
        const stringHeaders = window.localStorage.getItem('myHeaders');
        const storedHeaders = JSON.parse(stringHeaders);
        const date = new Date(e.target.value)
        const year = date.getFullYear();
        setMonthBtn("Month")
        setYearBtn(year)
        setSelectedBtn('year')
        setSelectedQuarter('Quarter')
        setStartDate("")
        setEndDate("")
        dispatch(setAnalyticsStartDate(`${year}-01-01`))
        dispatch(setAnalyticsEndDate(`${year}-12-31`))
        dispatch(setanalyticsType('year'))
        try {
            const resp = await axios.post(`${apiUrl}emp/analytics/get-single`, {
                userId: analyticsEmp,
                startDate: `${year}-01-01`,
                endDate: `${year}-12-31`,
                type: 'year'
            }, {
                headers: storedHeaders
            })
            if (resp && resp.data) {
                setIsYearAnalytics(false)
                dispatch(setAnalyticsData(resp.data))
            }
        } catch (err) {
            if (err.response && err.response.status === 500) {
                navigate("/server-error")
            }
           
        }
        if (isDetailAnalytics === true) {
            try {
                const resp = await axios.post(`${apiUrl}emp/analytics/get-assignee-list`, {
                    roleLevel: selfData && selfData.role && selfData.role.length > 0 ? selfData.role[0].roleLevel : 0,
                    startDate: `${year}-01-01`,
                    endDate: `${year}-12-31`,
                    key: '',
                    type: 'year'
                }, {
                    headers: storedHeaders
                })
                if (resp && resp.data) {
                    dispatch(setAnalyticsEmpList(resp.data))
                }
            } catch (err) {
                if (err.response && err.response.status === 500) {
                    navigate("/server-error")
                }
               
            }
        }
    }
    const empJoiningDate = useSelector((state) => state.data.empJoiningDate)

    const handleOverallAnalytics = async () => {
        setIsYearAnalytics(false)
        const stringHeaders = window.localStorage.getItem('myHeaders');
        const storedHeaders = JSON.parse(stringHeaders);
        const date = new Date()
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Adding 1 because getMonth() returns zero-based month
        const day = String(date.getDate()).padStart(2, '0');
        const formattedDate = `${year}-${month}-${day}`;
        setMonthBtn("Month")
        setYearBtn('Year')
        setSelectedBtn('overall')
        setSelectedQuarter('Quarter')
        setStartDate("")
        setEndDate("")
        dispatch(setAnalyticsStartDate(empJoiningDate))
        dispatch(setAnalyticsEndDate(formattedDate))
        dispatch(setanalyticsType('overall'))
        try {
            const resp = await axios.post(`${apiUrl}emp/analytics/get-single`, {
                userId: analyticsEmp,
                startDate: empJoiningDate,
                endDate: formattedDate,
                type: 'overall'

            }, {
                headers: storedHeaders
            })
            if (resp && resp.data) {
                setIsYearAnalytics(false)
                dispatch(setAnalyticsData(resp.data))
            }
        } catch (err) {
            if (err.response && err.response.status === 500) {
                navigate("/server-error")
            }
           
        }
        if (isDetailAnalytics === true) {
            try {
                const resp = await axios.post(`${apiUrl}emp/analytics/get-assignee-list`, {
                    roleLevel: selfData && selfData.role && selfData.role.length > 0 ? selfData.role[0].roleLevel : 0,
                    startDate: empJoiningDate,
                    endDate: formattedDate,
                    key: '',
                    type: 'overall'
                }, {
                    headers: storedHeaders
                })
                if (resp && resp.data) {
                    dispatch(setAnalyticsEmpList(resp.data))
                }
            } catch (err) {
                if (err.response && err.response.status === 500) {
                    navigate("/server-error")
                }
               
            }
        }
    }


    const isDateLessThanCurrent = (date) => {
        const givenDate = moment(date); // Convert string to Date object
        const currentDate = moment(empInfo ? empInfo.empJoiningDate : new Date()); // Get current date
        const validDate = moment(currentDate._d)
        // Compare the dates
        return givenDate >= validDate;
    };

    const handleCollaps = (e) => {
        const items = [];
        const levels = new Map();
        if (selfInfo.role && selfInfo.role.length > 0) {
            let val = true
            roles.forEach((role) => {
                if (val) {
                    val = !(role.roleName === e.node.label)
                }

                const newItem = {
                    key: `${role.roleLevel}-${role.roleId}`,
                    label: role.roleName,
                    expanded: val,
                    children: [],
                };

                if (role.roleLevel === selfInfo.role[0].roleLevel) {
                    items.push(newItem);
                    levels.set(selfInfo.role[0].roleLevel, newItem.children);
                } else {
                    const parentLevel = role.roleLevel - 1;
                    const parentItems = levels.get(parentLevel);

                    if (parentItems) {
                        parentItems.push(newItem);
                        if (!levels.has(role.roleLevel)) {
                            levels.set(role.roleLevel, newItem.children);
                        }
                    }
                }
            }
            );
        }
        setitems(items)
    }
    useEffect(() => {
        if (projectAllTskVar !== null && projectAllTskFlag === true) {
            setRouteS('projectAllTask')
        } else if (leaveCalenderViewFlag === true) {
            setRouteS('leaveCalenderView')
        } else if (scannerViewFlag === true) {
            setRouteS('scannerView')
        } else if (attendenceMonthViewFlag === true) {
            setRouteS('attendenceMonthView')
        } else if (myLeaveStatusFlag === true) {
            setRouteS('myLeaveStatus')
        } else if (attendenceMusteredFlag === true) {
            setRouteS('attendMusteredView')
        }

    }, [projectAllTskVar, leaveCalenderViewFlag, scannerViewFlag, attendenceMonthViewFlag, myLeaveStatusFlag, attendenceMusteredFlag])

    return (
        <div className='dashboard'>
            <div className='dash-header'>
                <div className='dash-header-container'>
                    <div className='dashHead-left-content'>
                        <img src={Logo} alt='logo' />
                    </div>
                    <div className='dashHead-right-content'>
                        <img className='profileImg' src={selfInfo.empImg ? selfInfo.empImg : profile} alt='/' onClick={editFrom} />
                        <p className='profileName' onClick={editFrom}>{selfData.empFullName}</p>
                        {/* <img onClick={() => {
                            dispatch(setReminders(true))
                        }} style={{ marginRight: '20px', cursor: 'pointer' }} className='reminderImg' src="./images/reminderNotify.png" alt='/' /> */}
                        <div className='notifaction-icon-container' onClick={() => {
                            dispatch(setNotifications(true))
                        }}>
                            {notifactionCont > 0 ? <div className='notification-count'>{formatNumberCount(notifactionCont)}</div> : null}
                            <svg

                                width="32" height="33" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fillRule="evenodd" clipRule="evenodd" d="M6.10305 0.0128568L6.08027 0.000677966C5.99553 0.000677966 5.91098 0.000677967 5.82725 0C5.50742 0.125153 5.38125 0.362911 5.41313 0.69835C5.41818 0.751721 5.4168 0.805763 5.41543 0.859865C5.41422 0.907526 5.413 0.955249 5.41618 1.00258C5.42228 1.09552 5.39515 1.13147 5.29543 1.14809C3.54023 1.44045 2.20187 2.9908 2.16863 4.77177C2.16199 5.12331 2.16308 5.47485 2.16418 5.82639C2.16471 5.99514 2.16523 6.16388 2.1649 6.33263C2.16388 6.93432 2.03805 7.5065 1.76129 8.04306C1.54355 8.46499 1.25254 8.82892 0.895392 9.14231C0.486015 9.50081 0.420555 10.056 0.735304 10.4603C0.946607 10.732 1.23219 10.8358 1.56932 10.8354C3.84334 10.8341 6.11737 10.8342 8.39139 10.8344L10.3382 10.8344L10.3527 10.8344C10.3817 10.8345 10.4106 10.8345 10.4396 10.8331C11.0145 10.8022 11.411 10.3528 11.3615 9.78232C11.3364 9.49471 11.176 9.28544 10.967 9.09788C10.2426 8.44735 9.82436 7.63538 9.76399 6.6623C9.74285 6.32142 9.74376 5.97907 9.74467 5.63665C9.74528 5.40772 9.74589 5.17875 9.73991 4.95018C9.73279 4.67681 9.72092 4.39835 9.66529 4.13176C9.33935 2.56615 8.16413 1.43129 6.58733 1.1447C6.51136 1.13079 6.49033 1.1006 6.49169 1.0287C6.49508 0.859794 6.4961 0.690209 6.49033 0.521303C6.48253 0.296773 6.36789 0.140754 6.16676 0.045787C6.14529 0.035552 6.12419 0.0242147 6.10305 0.0128568Z" fill="#FF8402" />
                                <path fillRule="evenodd" clipRule="evenodd" d="M1.94262 0.600171C0.731109 1.84831 0.087704 3.34235 0.00528583 5.07822C0.00528583 5.11598 0.00396383 5.15389 0.0026421 5.19179C-0.000322873 5.27683 -0.00328649 5.36182 0.00867773 5.44487C0.0449689 5.69721 0.25695 5.88002 0.503865 5.89121C0.771131 5.90342 0.996678 5.743 1.05773 5.48455C1.07558 5.40811 1.07737 5.32708 1.07915 5.24693C1.07953 5.22965 1.07991 5.21238 1.08045 5.19524C1.1103 4.27948 1.33788 3.41799 1.77948 2.61416C2.03352 2.15153 2.34793 1.73401 2.7183 1.35855C2.85363 1.22153 2.92926 1.0611 2.89535 0.86608C2.85736 0.647994 2.73085 0.497063 2.51717 0.431604C2.29095 0.362413 2.10305 0.434996 1.94262 0.600171ZM11.9034 5.07589C11.9034 5.11271 11.9047 5.14972 11.9059 5.18674C11.9088 5.26842 11.9116 5.35017 11.9007 5.42999C11.8613 5.7193 11.6202 5.90754 11.3288 5.89092C11.0561 5.87532 10.8329 5.64671 10.8296 5.36249C10.8221 4.73198 10.7292 4.11706 10.5257 3.51944C10.2628 2.74783 9.85139 2.06543 9.29482 1.47052C9.27796 1.45245 9.26085 1.4346 9.24373 1.41673C9.20818 1.37963 9.17255 1.34245 9.13914 1.30331C8.94615 1.07743 8.96006 0.759964 9.16966 0.558497C9.37893 0.35737 9.70792 0.343802 9.91312 0.55714C10.1556 0.809821 10.3917 1.07234 10.5999 1.35317C11.4187 2.45717 11.843 3.70395 11.9034 5.07589ZM7.92396 11.3788H3.97468C4.11679 12.2183 4.94877 13.0597 6.07956 12.9967C6.97633 12.9465 7.92362 12.1175 7.92396 11.3788Z" fill="#263238" />
                            </svg>
                        </div>
                        <svg className='logout-req' onClick={() => {
                            dispatch(setLogout(true))
                            }} width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M10.7778 2.77778V1.88889C10.7778 1.39797 10.3798 1 9.88889 1H1.88889C1.39796 1 1 1.39797 1 1.88889V16.1111C1 16.602 1.39797 17 1.88889 17H9.88889C10.3798 17 10.7778 16.602 10.7778 16.1111V15.2222" stroke="#7C8286" stroke-width="1.77778" stroke-linecap="round" />
                            <path d="M7.44531 9H17.2231" stroke="#263238" stroke-width="1.77778" stroke-linecap="round" />
                            <path d="M14.1094 5.88867L17.2205 8.99978L14.1094 12.1109" stroke="#263238" stroke-width="1.77778" stroke-linecap="round" />
                        </svg>
                    </div>
                </div>
            </div>
            <div className='dashboardView'>
                <div className='dashboardView-container'>
                    <div className='dashboard-left-menu'>
                        <div className='dashboard-left-menu-scroller'>
                            <div className='dashboard-left-menu-continer'>
                                <div className='myTask' onClick={() => {
                                    if (routeS === 'mytask') {
                                        return
                                    }
                                    handleRoute("mytask");
                                    dispatch(setEmpView(false))
                                    dispatch(setHeader("Tasks"))
                                    window.sessionStorage.setItem('header', 'Tasks')
                                    dispatch(setmtiID(true))
                                    dispatch(setEmpInfo(selfData))
                                    dispatch(setTaskEmp(selfData))
                                    dispatch(setEditeKey(true))
                                    dispatch(setView('month'))
                                    window.sessionStorage.setItem('view', 'month')
                                }} style={{ backgroundColor: routeS === 'mytask' ? '#D9D9D9' : null }}>
                                    <svg width="30" height="34" viewBox="0 0 15 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M14.8512 13.776C14.9484 13.6745 15.002 13.5389 15.0002 13.3983C14.9984 13.2577 14.9415 13.1235 14.8416 13.0245C14.7418 12.9255 14.6071 12.8697 14.4665 12.8691C14.326 12.8686 14.1908 12.9232 14.0901 13.0214L10.1853 16.9659L8.42201 15.1673C8.37302 15.1159 8.31429 15.0747 8.24925 15.0462C8.1842 15.0176 8.11414 15.0023 8.04312 15.0011C7.97211 14.9999 7.90156 15.0128 7.83558 15.0391C7.7696 15.0654 7.70951 15.1045 7.65879 15.1543C7.60807 15.204 7.56775 15.2633 7.54015 15.3287C7.51256 15.3942 7.49824 15.4645 7.49805 15.5355C7.49785 15.6065 7.51178 15.6769 7.53901 15.7425C7.56624 15.8081 7.60624 15.8676 7.65668 15.9176L9.72435 18.0271C9.78405 18.088 9.85527 18.1364 9.93386 18.1695C10.0124 18.2026 10.0968 18.2198 10.1821 18.22C10.2674 18.2202 10.3519 18.2034 10.4306 18.1707C10.5094 18.1379 10.5808 18.0898 10.6408 18.0292L14.8512 13.776Z" fill="#FF8402" />
                                        <path d="M0 2.14377C0 1.5752 0.22586 1.02993 0.627894 0.627894C1.02993 0.22586 1.5752 0 2.14377 0H10.7188C11.2874 0 11.8327 0.22586 12.2347 0.627894C12.6367 1.02993 12.8626 1.5752 12.8626 2.14377V12.7372L10.1882 15.4383L9.18711 14.4168C9.04013 14.2626 8.86395 14.139 8.66882 14.0535C8.47369 13.9679 8.26349 13.9219 8.05044 13.9183C7.8374 13.9147 7.62576 13.9534 7.42782 14.0323C7.22989 14.1112 7.0496 14.2286 6.89745 14.3778C6.7453 14.527 6.62432 14.7049 6.54153 14.9012C6.45875 15.0976 6.41581 15.3084 6.41523 15.5215C6.41464 15.7345 6.45641 15.9456 6.53811 16.1424C6.61981 16.3392 6.73981 16.5178 6.89113 16.6678L7.36383 17.1501H2.14377C1.5752 17.1501 1.02993 16.9243 0.627894 16.5222C0.22586 16.1202 0 15.5749 0 15.0064V2.14377ZM5.35941 8.03912C5.35941 8.18126 5.41588 8.31758 5.51639 8.41809C5.6169 8.5186 5.75322 8.57506 5.89536 8.57506H10.1829C10.325 8.57506 10.4613 8.5186 10.5619 8.41809C10.6624 8.31758 10.7188 8.18126 10.7188 8.03912C10.7188 7.89698 10.6624 7.76066 10.5619 7.66015C10.4613 7.55964 10.325 7.50318 10.1829 7.50318H5.89536C5.75322 7.50318 5.6169 7.55964 5.51639 7.66015C5.41588 7.76066 5.35941 7.89698 5.35941 8.03912ZM5.89536 3.21565C5.75322 3.21565 5.6169 3.27211 5.51639 3.37262C5.41588 3.47313 5.35941 3.60945 5.35941 3.75159C5.35941 3.89373 5.41588 4.03005 5.51639 4.13056C5.6169 4.23107 5.75322 4.28753 5.89536 4.28753H10.1829C10.325 4.28753 10.4613 4.23107 10.5619 4.13056C10.6624 4.03005 10.7188 3.89373 10.7188 3.75159C10.7188 3.60945 10.6624 3.47313 10.5619 3.37262C10.4613 3.27211 10.325 3.21565 10.1829 3.21565H5.89536ZM5.35941 12.3267C5.35941 12.4688 5.41588 12.6051 5.51639 12.7056C5.6169 12.8061 5.75322 12.8626 5.89536 12.8626H10.1829C10.325 12.8626 10.4613 12.8061 10.5619 12.7056C10.6624 12.6051 10.7188 12.4688 10.7188 12.3267C10.7188 12.1845 10.6624 12.0482 10.5619 11.9477C10.4613 11.8472 10.325 11.7907 10.1829 11.7907H5.89536C5.75322 11.7907 5.6169 11.8472 5.51639 11.9477C5.41588 12.0482 5.35941 12.1845 5.35941 12.3267ZM3.21565 9.111C3.49993 9.111 3.77257 8.99807 3.97358 8.79706C4.1746 8.59604 4.28753 8.3234 4.28753 8.03912C4.28753 7.75484 4.1746 7.4822 3.97358 7.28119C3.77257 7.08017 3.49993 6.96724 3.21565 6.96724C2.93137 6.96724 2.65873 7.08017 2.45771 7.28119C2.2567 7.4822 2.14377 7.75484 2.14377 8.03912C2.14377 8.3234 2.2567 8.59604 2.45771 8.79706C2.65873 8.99807 2.93137 9.111 3.21565 9.111ZM4.28753 3.75159C4.28753 3.46731 4.1746 3.19467 3.97358 2.99365C3.77257 2.79264 3.49993 2.67971 3.21565 2.67971C2.93137 2.67971 2.65873 2.79264 2.45771 2.99365C2.2567 3.19467 2.14377 3.46731 2.14377 3.75159C2.14377 4.03587 2.2567 4.30851 2.45771 4.50953C2.65873 4.71054 2.93137 4.82347 3.21565 4.82347C3.49993 4.82347 3.77257 4.71054 3.97358 4.50953C4.1746 4.30851 4.28753 4.03587 4.28753 3.75159ZM3.21565 13.3985C3.49993 13.3985 3.77257 13.2856 3.97358 13.0846C4.1746 12.8836 4.28753 12.6109 4.28753 12.3267C4.28753 12.0424 4.1746 11.7697 3.97358 11.5687C3.77257 11.3677 3.49993 11.2548 3.21565 11.2548C2.93137 11.2548 2.65873 11.3677 2.45771 11.5687C2.2567 11.7697 2.14377 12.0424 2.14377 12.3267C2.14377 12.6109 2.2567 12.8836 2.45771 13.0846C2.65873 13.2856 2.93137 13.3985 3.21565 13.3985Z" fill="#263238" />
                                    </svg>
                                    <p>My Tasks</p>
                                </div>
                                <div className='levelMainContainer' style={{ background: routeS === 'level' ? '#d9d9d9' : "#ffffff" }}>
                                    <div className="card flex justify-content-center">
                                        <Tree value={items} selectionMode="single"
                                            onCollapse={(e) => handleCollaps(e)}
                                            onSelect={onSelect} className="w-full md:w-30rem" />
                                    </div>
                                </div>

                                <div className='projects Analytics-tab' onClick={() => {
                                    handleRoute("analytics");
                                    dispatch(setEmpView(false))
                                    dispatch(setHeader("Analytics"))
                                    setStartDate(null);
                                    setEndDate(null);
                                    window.sessionStorage.setItem('header', 'Analytics')
                                    dispatch(setIsDetailAnalytics(true))
                                    dispatch(setAnalyticsEmp(self.userId))
                                    const date = new Date()
                                    const year = date.getFullYear();
                                    setMonthBtn("Month")
                                    setYearBtn(year)
                                    setSelectedBtn('year')
                                    setSelectedQuarter('Quarter')
                                    dispatch(setAnalyticsStartDate(`${year}-01-01`))
                                    dispatch(setAnalyticsEndDate(`${year}-12-31`))
                                    dispatch(setEmpJoiningDate(self.empJoiningDate))
                                    window.sessionStorage.setItem("userId", self.userId)
                                }} style={{ backgroundColor: routeS === 'analytics' ? '#D9D9D9' : null }}>
                                    <svg width="17" height="10" viewBox="0 0 17 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M12 5.5L14.5 3M8 3.5L9.5 5M3 6.5L6 3.5" stroke="#263238" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M15.1981 3.10718C15.9181 3.10718 16.5017 2.52354 16.5017 1.80359C16.5017 1.08364 15.9181 0.5 15.1981 0.5C14.4782 0.5 13.8945 1.08364 13.8945 1.80359C13.8945 2.52354 14.4782 3.10718 15.1981 3.10718Z" stroke="#263238" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M10.6395 7.66187C11.3595 7.66187 11.9431 7.07823 11.9431 6.35828C11.9431 5.63833 11.3595 5.05469 10.6395 5.05469C9.91958 5.05469 9.33594 5.63833 9.33594 6.35828C9.33594 7.07823 9.91958 7.66187 10.6395 7.66187Z" stroke="#263238" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M6.89343 3.91187C7.61339 3.91187 8.19703 3.32823 8.19703 2.60828C8.19703 1.88833 7.61339 1.30469 6.89343 1.30469C6.17348 1.30469 5.58984 1.88833 5.58984 2.60828C5.58984 3.32823 6.17348 3.91187 6.89343 3.91187Z" stroke="#263238" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M1.80359 8.99976C2.52354 8.99976 3.10718 8.41612 3.10718 7.69617C3.10718 6.97622 2.52354 6.39258 1.80359 6.39258C1.08364 6.39258 0.5 6.97622 0.5 7.69617C0.5 8.41612 1.08364 8.99976 1.80359 8.99976Z" stroke="#263238" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>


                                    <p>Analytics</p>
                                </div>

                                <div className='requestsNotify' onClick={() => {
                                    handleRoute("requests")
                                    dispatch(setHeader("Requests"))
                                    window.sessionStorage.setItem('header', 'Requests')
                                }}
                                    style={{ backgroundColor: routeS === 'requests' ? '#D9D9D9' : null }}>
                                    <div className='requestNotify_SubDiv'>
                                        <svg width="30" height="40" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ width: '30px' }}>
                                            <path d="M11.9519 0.044825C12.2642 0.0945237 12.5812 0.125439 12.888 0.198226C13.6362 0.375889 14.2682 0.734345 14.6599 1.42934C15.2496 2.47497 15.0595 3.98902 14.2381 4.76777C13.7747 5.20684 13.2022 5.41502 12.5863 5.52264C12.0055 5.62399 11.4217 5.63064 10.8351 5.58134C10.7552 5.57468 10.6695 5.58721 10.5921 5.6099C10.0829 5.76096 9.57539 5.91788 9.06705 6.07167C8.68394 6.1875 8.4288 5.99849 8.43036 5.60012C8.43153 5.22914 8.43858 4.85816 8.43349 4.48718C8.43232 4.40461 8.40884 4.31304 8.36814 4.24143C7.79954 3.24902 7.94707 1.76549 8.70272 0.971099C9.13671 0.515201 9.68887 0.282753 10.2935 0.162223C10.551 0.110959 10.8132 0.0831751 11.073 0.0444336C11.3661 0.0448249 11.6588 0.044825 11.9519 0.044825ZM10.0986 3.50534C10.3404 3.50534 10.5392 3.3085 10.5396 3.0694C10.5396 2.83421 10.335 2.62916 10.0994 2.62876C9.85988 2.62837 9.66304 2.82678 9.66265 3.06901C9.66265 3.31242 9.85558 3.50534 10.0986 3.50534ZM11.5085 3.50534C11.75 3.50377 11.948 3.3042 11.9457 3.06549C11.9433 2.82952 11.7367 2.62603 11.5019 2.62837C11.262 2.63072 11.0675 2.82991 11.0691 3.07214C11.0703 3.31555 11.2648 3.50691 11.5085 3.50534ZM12.9099 3.50534C13.1517 3.50573 13.3509 3.30968 13.3517 3.07018C13.3525 2.83499 13.1478 2.62955 12.9122 2.62876C12.6731 2.62798 12.4755 2.82639 12.4747 3.06823C12.4743 3.31163 12.6669 3.50534 12.9099 3.50534Z" fill="#263238" />
                                            <path d="M0 13.3144C0.00978321 13.2878 0.0223061 13.2619 0.0285674 13.2349C0.180403 12.5614 0.590906 12.1337 1.25969 11.9682C1.67567 11.8653 2.0983 11.7886 2.51624 11.6931C2.59646 11.6747 2.63833 11.695 2.68921 11.753C3.7364 12.9367 5.57917 12.9399 6.61932 11.7588C6.67958 11.6903 6.73085 11.6751 6.8189 11.6954C7.22705 11.7897 7.63873 11.8711 8.04688 11.9651C8.80841 12.14 9.30735 12.7649 9.314 13.5464C9.31674 13.8834 9.31557 14.2199 9.31439 14.5568C9.31322 14.8609 9.13556 15.0421 8.83424 15.0421C6.05189 15.0429 3.26994 15.0413 0.487595 15.0444C0.24458 15.0448 0.101354 14.92 0 14.7204C0 14.2516 0 13.7828 0 13.3144Z" fill="#263238" />
                                            <path d="M6.83005 6.90957C6.7964 7.44256 6.88992 7.97164 6.7463 8.48936C6.47355 9.47395 5.53319 10.1541 4.54391 10.084C3.49437 10.0097 2.63814 9.23328 2.52231 8.20291C2.47496 7.78028 2.51448 7.34786 2.51448 6.90918C3.93383 6.90957 5.36961 6.90957 6.83005 6.90957Z" fill="#263238" />
                                            <path d="M2.49863 6.01236C2.45089 5.46059 2.54637 4.96634 2.93301 4.56249C3.23707 4.24473 3.61079 4.0659 4.04947 4.06198C5.0587 4.05259 6.06833 4.0569 7.07796 4.05885C7.33662 4.05925 7.52094 4.24356 7.52681 4.49988C7.5315 4.70455 7.53229 4.9096 7.52602 5.11427C7.51115 5.61047 7.11083 6.0155 6.61227 6.01745C5.26141 6.02332 3.91054 6.0198 2.55968 6.01941C2.54168 6.0198 2.52289 6.0155 2.49863 6.01236Z" fill="#263238" />
                                            <path d="M3.20874 10.6017C4.17062 11.085 5.13446 11.0869 6.11083 10.6001C6.12844 10.8052 6.14291 10.982 5.98991 11.1554C5.30117 11.9357 4.09744 11.9643 3.38014 11.2157C3.20756 11.036 3.15708 10.8443 3.20874 10.6017Z" fill="#263238" />
                                        </svg>
                                        <p>Request {pendingReq && pendingReq > 0 ? <div className={`requestCount ${pendingReq > 20 ? 'blinking-div' : null}`}>{pendingReq}</div> : <div />}</p>
                                    </div>
                                </div>


                                <div className='projects' onClick={() => {
                                    handleRoute("projects");
                                    dispatch(setEmpView(false))
                                    dispatch(setHeader("Projects"))
                                    window.sessionStorage.setItem('header', 'Projects')
                                }} style={{ backgroundColor: routeS === 'projects' ? '#D9D9D9' : null }}>
                                    <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M8.25 10.1111H6.75C6.3375 10.1111 6 9.76111 6 9.33333H0.7575V12.4444C0.7575 13.3 1.4325 14 2.2575 14H12.75C13.575 14 14.25 13.3 14.25 12.4444V9.33333H9C9 9.76111 8.6625 10.1111 8.25 10.1111ZM13.5 3.11111H10.5C10.5 1.39222 9.1575 0 7.5 0C5.8425 0 4.5 1.39222 4.5 3.11111H1.5C0.675 3.11111 0 3.81111 0 4.66667V7C0 7.86333 0.6675 8.55556 1.5 8.55556H6V7.77778C6 7.35 6.3375 7 6.75 7H8.25C8.6625 7 9 7.35 9 7.77778V8.55556H13.5C14.325 8.55556 15 7.85556 15 7V4.66667C15 3.81111 14.325 3.11111 13.5 3.11111ZM6 3.11111C6 2.25556 6.675 1.55556 7.5 1.55556C8.325 1.55556 9 2.25556 9 3.11111H5.9925H6Z" fill="#263238" />
                                    </svg>

                                    <p>Projects</p>
                                </div>

                                <div className='projects' onClick={() => {
                                    handleRoute("closureReport");
                                }}

                                    style={{ backgroundColor: routeS === 'closureReport' ? '#D9D9D9' : null }}>
                                    <svg width="18" height="12" viewBox="0 0 18 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M11.9732 6.00083C11.498 6.00083 11.0508 5.75976 10.8089 5.37406L9.00062 2.51878L7.19511 5.37406C6.95044 5.76244 6.50328 6.00351 6.028 6.00351C5.90144 6.00351 5.77489 5.98744 5.65396 5.95262L1.80108 4.90264V9.67037C1.80108 10.0641 2.08231 10.407 2.48166 10.5007L8.5619 11.9498C8.84876 12.0167 9.14968 12.0167 9.43372 11.9498L15.5196 10.5007C15.9189 10.4043 16.2002 10.0614 16.2002 9.67037V4.90264L12.3473 5.94994C12.2264 5.98476 12.0998 6.00083 11.9732 6.00083ZM17.9522 2.99555L16.5039 0.242055C16.4167 0.0759881 16.2283 -0.020438 16.0342 0.00366855L9.00062 0.85811L11.5795 4.93211C11.6864 5.10085 11.9001 5.18121 12.0998 5.12764L17.6654 3.61429C17.9438 3.53661 18.0788 3.24198 17.9522 2.99555ZM1.49735 0.242055L0.0489998 2.99555C-0.080367 3.24198 0.0574368 3.53661 0.333044 3.61161L5.89863 5.12496C6.09831 5.17853 6.31204 5.09818 6.41891 4.92943L9.00062 0.85811L1.96419 0.00366855C1.77014 -0.0177595 1.58453 0.0759881 1.49735 0.242055Z" fill="#263238" />
                                    </svg>
                                    <p>Closure Report</p>
                                </div>


                                {selfInfo && selfInfo.role && (selfInfo.role[0].roleLevel === 1 || selfInfo.role[0].roleLevel === 2) ?
                                    <div className='employee' onClick={() => {
                                        handleRoute("employee")
                                        dispatch(setHeader("Employee"))
                                        window.sessionStorage.setItem('header', 'Employee')
                                    }} style={{ backgroundColor: routeS === 'employee' ? '#D9D9D9' : null }}>
                                        <svg width="15" height="11" viewBox="0 0 15 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M10.9928 10.9942C8.65788 10.9942 6.34176 10.9942 4.01313 10.9942C4.00896 10.9537 4.00145 10.9145 4.00145 10.8753C4.00103 10.0683 3.98768 9.26098 4.00478 8.45403C4.02899 7.32372 4.50005 6.40913 5.39212 5.71192C5.54316 5.59384 5.70839 5.55003 5.88905 5.61219C6.2508 5.73653 6.61005 5.86922 7.00017 6.00941C7.00017 6.02276 7.00017 6.07825 7.00017 6.13375C7.00017 6.91983 6.9985 7.70634 7.00142 8.49242C7.00267 8.7557 7.19502 8.96724 7.44495 8.9952C7.69488 9.02357 7.93312 8.85292 7.98737 8.60132C8.0003 8.54124 7.99947 8.4774 7.99947 8.41523C8.0003 7.66044 7.99989 6.90523 7.99989 6.15044C7.99989 6.09328 7.99989 6.03653 7.99989 5.96602C8.10461 5.94432 8.20767 5.93264 8.30405 5.90093C8.54063 5.82332 8.77846 5.7478 9.00752 5.65058C9.23158 5.55545 9.42727 5.56922 9.61962 5.72068C10.4988 6.41414 10.9669 7.31997 10.994 8.43776C11.0136 9.25473 10.9986 10.0725 10.9986 10.8899C10.9978 10.9199 10.9949 10.9504 10.9928 10.9942Z" fill="#263238" />
                                            <path d="M7.50681 4.20635e-06C8.88497 0.00292491 10.0032 1.13157 9.99775 2.51473C9.99191 3.88495 8.86536 5.00149 7.49096 4.99857C6.1128 4.99565 4.9946 3.86618 5.00002 2.48302C5.00544 1.11279 6.13116 -0.00249925 7.50681 4.20635e-06Z" fill="#263238" />
                                            <path d="M11.9965 10.9859C11.9965 10.2582 11.9839 9.54011 11.9998 8.82245C12.019 7.95751 11.8679 7.13596 11.4549 6.3699C11.4478 6.35697 11.4457 6.34111 11.4336 6.2998C11.5162 6.31816 11.5859 6.32609 11.6506 6.34904C12.2109 6.5489 12.7709 6.55307 13.3308 6.35071C13.5327 6.27769 13.7138 6.30022 13.8907 6.42581C14.5971 6.9265 14.9752 7.60619 14.9927 8.47239C15.006 9.13831 14.9973 9.80506 14.9952 10.471C14.9943 10.7764 14.7903 10.9955 14.4957 10.9971C13.6838 11.0013 12.8718 10.9984 12.0599 10.998C12.0444 10.9971 12.0298 10.9921 11.9965 10.9859Z" fill="#263238" />
                                            <path d="M2.99975 10.9966C2.14023 10.9966 1.30282 11.0012 0.465418 10.9936C0.223835 10.9916 0.0068685 10.7834 0.00645126 10.543C0.00561677 9.74192 -0.0210877 8.93789 0.0406642 8.14096C0.0994954 7.38241 0.530508 6.80745 1.1618 6.38854C1.30533 6.2934 1.46305 6.27964 1.62452 6.33888C2.20991 6.55335 2.79447 6.55168 3.37986 6.33805C3.43118 6.31927 3.48834 6.31552 3.57054 6.29883C3.50211 6.44361 3.44328 6.56169 3.38946 6.68227C3.13077 7.26558 2.9985 7.87559 2.99892 8.51439C2.99975 9.27961 2.99892 10.0448 2.99892 10.8101C2.99975 10.8664 2.99975 10.9227 2.99975 10.9966Z" fill="#263238" />
                                            <path d="M2.50374 2.00098C3.60109 2.00307 4.49774 2.9039 4.49649 4.0025C4.49524 5.10736 3.59066 6.00484 2.4833 5.99984C1.38803 5.99441 0.495133 5.09067 0.498054 3.98998C0.501809 2.89388 1.40431 1.99848 2.50374 2.00098Z" fill="#263238" />
                                            <path d="M12.4883 5.99945C11.3918 5.99611 10.4968 5.09445 10.498 3.99501C10.4997 2.8914 11.406 1.99475 12.5137 2.00101C13.609 2.00727 14.5011 2.91268 14.4961 4.01295C14.4915 5.10947 13.5886 6.00278 12.4883 5.99945Z" fill="#263238" />
                                        </svg>
                                        <p>Employee</p>
                                    </div> : null
                                }

                                <div className='myTask' onClick={() => {
                                    handleRoute("settings");
                                    dispatch(setHeader("Settings"))
                                    dispatch(setLeaveCalenderViewFlag(false))
                                    dispatch(setScannerViewFlag(false))
                                    dispatch(setAttendenceMontViewFlag(false))
                                    dispatch(setMyLeaveStatusFlag(false))
                                    dispatch(setMyLeaveStatusFlag(false))
                                    dispatch(setAttendMusteredFlag(false))
                                    dispatch(setPrjAllTaskFlg(false))
                                    window.sessionStorage.setItem('header', 'Settings')
                                    window.sessionStorage.setItem('view', 'month')
                                    dispatch(setInfoShow(''))
                                }} style={{ backgroundColor: routeS === 'settings' ? '#D9D9D9' : null }}>
                                    <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M6.0023 4.73004C5.57892 4.73004 5.18244 4.89859 4.88225 5.20661C4.58347 5.51463 4.4178 5.92145 4.4178 6.35588C4.4178 6.79031 4.58347 7.19713 4.88225 7.50516C5.18244 7.81173 5.57892 7.98172 6.0023 7.98172C6.42569 7.98172 6.82217 7.81173 7.12236 7.50516C7.42114 7.19713 7.58681 6.79031 7.58681 6.35588C7.58681 5.92145 7.42114 5.51463 7.12236 5.20661C6.97574 5.055 6.80122 4.93481 6.60894 4.85299C6.41666 4.77118 6.21046 4.72939 6.0023 4.73004ZM11.8405 8.15172L10.9144 7.33952C10.9583 7.06347 10.981 6.78159 10.981 6.50118C10.981 6.22076 10.9583 5.93744 10.9144 5.66283L11.8405 4.85064C11.9104 4.78919 11.9605 4.70734 11.984 4.61599C12.0075 4.52463 12.0034 4.42809 11.9722 4.3392L11.9594 4.30143C11.7046 3.57015 11.3227 2.8923 10.8323 2.30073L10.8068 2.27022C10.7472 2.19837 10.6679 2.14673 10.5792 2.12209C10.4904 2.09745 10.3965 2.10097 10.3098 2.13219L9.15999 2.55209C8.73519 2.19466 8.26224 1.91279 7.74965 1.71665L7.52734 0.483102C7.51056 0.390176 7.46663 0.304685 7.40138 0.237988C7.33612 0.171292 7.25264 0.126546 7.16201 0.109697L7.12378 0.102432C6.38746 -0.0341441 5.61149 -0.0341441 4.87517 0.102432L4.83693 0.109697C4.74631 0.126546 4.66282 0.171292 4.59756 0.237988C4.53231 0.304685 4.48838 0.390176 4.47161 0.483102L4.24788 1.72246C3.74014 1.92017 3.26715 2.20136 2.84745 2.55499L1.68916 2.13219C1.60246 2.10072 1.50847 2.09707 1.41969 2.12173C1.33091 2.14638 1.25155 2.19817 1.19215 2.27022L1.16666 2.30073C0.677137 2.89293 0.295353 3.57061 0.0395221 4.30143L0.0267781 4.3392C-0.0369419 4.52082 0.0154501 4.72423 0.158466 4.85064L1.09586 5.67155C1.05196 5.9447 1.03072 6.22367 1.03072 6.49972C1.03072 6.77869 1.05196 7.05765 1.09586 7.3279L0.161298 8.14881C0.0913417 8.21026 0.0412729 8.29211 0.0177496 8.38346C-0.00577364 8.47482 -0.00163684 8.57136 0.0296101 8.66024L0.0423541 8.69802C0.29865 9.42885 0.676723 10.1045 1.16949 10.6987L1.19498 10.7292C1.25453 10.8011 1.33389 10.8527 1.42262 10.8774C1.51134 10.902 1.60526 10.8985 1.692 10.8673L2.85028 10.4445C3.27225 10.8004 3.74237 11.0823 4.25071 11.277L4.47444 12.5163C4.49121 12.6093 4.53514 12.6948 4.6004 12.7615C4.66565 12.8282 4.74914 12.8729 4.83977 12.8898L4.878 12.897C5.62156 13.0343 6.38304 13.0343 7.12661 12.897L7.16484 12.8898C7.25547 12.8729 7.33896 12.8282 7.40421 12.7615C7.46946 12.6948 7.5134 12.6093 7.53017 12.5163L7.75248 11.2828C8.26507 11.0852 8.73802 10.8048 9.16282 10.4474L10.3126 10.8673C10.3993 10.8987 10.4933 10.9024 10.5821 10.8777C10.6709 10.8531 10.7502 10.8013 10.8096 10.7292L10.8351 10.6987C11.3279 10.1016 11.706 9.42885 11.9623 8.69802L11.975 8.66024C12.0359 8.48008 11.9835 8.27812 11.8405 8.15172ZM6.0023 8.91015C4.62737 8.91015 3.51297 7.76669 3.51297 6.35588C3.51297 4.94508 4.62737 3.80162 6.0023 3.80162C7.37724 3.80162 8.49163 4.94508 8.49163 6.35588C8.49163 7.76669 7.37724 8.91015 6.0023 8.91015Z" fill="#263238" />
                                    </svg>
                                    <p>Settings</p>
                                </div>

                                {/* {selfInfo && selfInfo.role && (selfInfo.role[0].roleLevel === 1 || selfInfo.role[0].roleLevel === 2) ?
                                    <div className='information' onClick={() => {
                                        handleRoute("info")
                                        dispatch(setHeader("Information"))
                                        window.sessionStorage.setItem('header', 'Information')
                                    }} style={{ backgroundColor: routeS === 'info' ? '#D9D9D9' : null }}>
                                        <svg width="23.44" height="25" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M7.5 0.0444336C6.01664 0.0444336 4.56659 0.484301 3.33323 1.30841C2.09986 2.13252 1.13856 3.30386 0.570907 4.67431C0.00324963 6.04475 -0.145275 7.55275 0.144114 9.00761C0.433503 10.4625 1.14781 11.7988 2.1967 12.8477C3.2456 13.8966 4.58197 14.6109 6.03682 14.9003C7.49168 15.1897 8.99968 15.0412 10.3701 14.4735C11.7406 13.9059 12.9119 12.9446 13.736 11.7112C14.5601 10.4778 15 9.02779 15 7.54443C14.9979 5.55595 14.207 3.64952 12.801 2.24345C11.3949 0.837384 9.48848 0.0465335 7.5 0.0444336ZM7.21154 3.50597C7.3827 3.50597 7.55001 3.55673 7.69232 3.65181C7.83463 3.7469 7.94555 3.88206 8.01105 4.04019C8.07655 4.19832 8.09369 4.37232 8.0603 4.54018C8.02691 4.70805 7.94449 4.86225 7.82346 4.98327C7.70243 5.1043 7.54824 5.18672 7.38037 5.22011C7.2125 5.2535 7.0385 5.23637 6.88037 5.17087C6.72224 5.10537 6.58709 4.99445 6.492 4.85214C6.39691 4.70983 6.34616 4.54251 6.34616 4.37136C6.34616 4.14184 6.43733 3.92173 6.59962 3.75944C6.76191 3.59715 6.98203 3.50597 7.21154 3.50597ZM8.07692 11.5829C7.77091 11.5829 7.47742 11.4613 7.26103 11.2449C7.04464 11.0286 6.92308 10.7351 6.92308 10.429V7.54443C6.77007 7.54443 6.62333 7.48365 6.51513 7.37545C6.40694 7.26726 6.34616 7.12052 6.34616 6.96751C6.34616 6.8145 6.40694 6.66776 6.51513 6.55956C6.62333 6.45137 6.77007 6.39059 6.92308 6.39059C7.2291 6.39059 7.52258 6.51215 7.73897 6.72854C7.95536 6.94493 8.07692 7.23841 8.07692 7.54443V10.429C8.22993 10.429 8.37668 10.4898 8.48487 10.598C8.59307 10.7062 8.65385 10.853 8.65385 11.006C8.65385 11.159 8.59307 11.3057 8.48487 11.4139C8.37668 11.5221 8.22993 11.5829 8.07692 11.5829Z" fill="#263238" />
                                        </svg>
                                        <p>Information</p>
                                    </div> : null
                                } */}
                            </div>
                        </div>

                        <div className='closureBtnDiv' onClick={() => {
                            const stringHeaders = window.localStorage.getItem('myHeaders');
                            const storedHeaders = JSON.parse(stringHeaders);
                            axios.post(`${apiUrl}email/check/key`, {
                                userId: selfData.userId
                            }, {
                                headers: storedHeaders
                            })
                                .then((response) => {
                                    if (response.data) {
                                        dispatch(setClosureMail(true))
                                    }
                                    else {
                                        toast.error("Please submit your email access key in user profile", { autoClose: false })
                                        dispatch(setClosureProcedure(true))
                                    }
                                })
                                .catch((error) => {
                                    if (error.response.status === 404) {
                                        toast.error("Please update your official email", { autoClose: 2000 })

                                    } else {
                                        toast.error("Server Error", { autoClose: 2000 })
                                    }

                                    if (error.response && error.response.status === 500) {
                                        navigate("/server-error")
                                    }

                                })

                        }}>
                            <div className='closureMainBtn'>
                                <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M14.6458 0C14.401 0 14.168 0.110885 13.9721 0.306565L13.5035 0.754671L16.2567 3.50593L16.7058 3.0376C17.0975 2.64624 17.0975 2.06312 16.7058 1.67176L15.339 0.305913C15.1432 0.110233 14.8905 0 14.6458 0ZM13.0544 1.14212L12.3403 1.73372L15.2776 4.66892L15.9304 4.01665L13.0544 1.14212ZM11.9526 2.20205L6.05836 8.032C6.02852 8.05662 6.00099 8.08391 5.97611 8.11353L5.93564 8.13375C5.86444 8.21528 5.81524 8.31361 5.79269 8.41945L4.997 11.2118C4.9629 11.3223 4.9596 11.44 4.98747 11.5523C5.01534 11.6646 5.07331 11.7671 5.15515 11.8489C5.23699 11.9307 5.33961 11.9886 5.45194 12.0164C5.56428 12.0443 5.68209 12.041 5.79269 12.0069L8.58706 11.2118C8.67984 11.1898 8.76649 11.1473 8.84061 11.0873C8.91472 11.0274 8.97441 10.9515 9.01526 10.8654L14.809 5.13724L13.7071 3.95469V4.016L12.9317 3.24111H12.993L11.9526 2.20205ZM6.93564 9.05084L7.83315 9.1115L7.89451 10.0899L6.99699 10.3547L6.65039 10.009L6.93564 9.05084Z" fill="#FF8402" />
                                    <path d="M0.530777 2.65013C0.379557 2.67888 0.243367 2.76009 0.146263 2.87945C0.0491592 2.9988 -0.00260951 3.1486 0.000101306 3.3024V16.3477C0.000101306 16.5207 0.0688717 16.6866 0.191284 16.8089C0.313696 16.9313 0.479722 17 0.652839 17H13.7076C13.8807 17 14.0467 16.9313 14.1691 16.8089C14.2916 16.6866 14.3603 16.5207 14.3603 16.3477V9.17279C14.3603 8.9998 14.2916 8.83389 14.1691 8.71157C14.0467 8.58925 13.8807 8.52053 13.7076 8.52053C13.5345 8.52053 13.3684 8.58925 13.246 8.71157C13.1236 8.83389 13.0549 8.9998 13.0549 9.17279V15.6954H1.30558V3.95467H7.83295C8.00607 3.95467 8.1721 3.88595 8.29451 3.76362C8.41692 3.6413 8.48569 3.47539 8.48569 3.3024C8.48569 3.12941 8.41692 2.9635 8.29451 2.84118C8.1721 2.71886 8.00607 2.65013 7.83295 2.65013H0.652839C0.632398 2.64917 0.611923 2.64917 0.591482 2.65013C0.571041 2.64917 0.551218 2.64917 0.530777 2.65013Z" fill="#263238" />
                                </svg>
                                <p>Create Closure</p>
                            </div>
                        </div>
                    </div>
                    <div className='dashboard-main-container'>
                        {routeS !== 'closureReport' && routeS !== 'meettingsCards' && routeS !== 'projectAllTask' && routeS !== 'requests' && routeS !== 'leaveCalenderView' && routeS !== 'scannerView' && routeS !== 'attendenceMonthView' && routeS !== 'myLeaveStatus' && routeS !== 'attendMusteredView' ?
                            <div className='dashboard-head'>
                                <div className='dashboard-text-containt'>
                                    <div style={{fontSize : '20px'}}>{header}</div>
                                    {(view === 'day' || routeS === "level") && (view !== 'month' && view !== 'week' && routeS !== "projects") && routeS !== "employee" && routeS !== 'requests' && routeS !== 'info' && routeS !== 'settings' && routeS !== 'analytics' ?
                                        <div className='dayViewDateSeletor'>
                                            <svg onClick={handlePrevDate} width="6" height="11" viewBox="0 0 6 11" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ cursor: 'pointer' }}>
                                                <path d="M5.19231 0L6 0.916667L1.73077 5.5L6 10.0833L5.19231 11L4.76837e-07 5.5L5.19231 0Z" fill="#FF8402" />
                                            </svg>
                                            <div className='date-holder-dashboard'>
                                                <p onClick={() => setIsDateRoute(true)}>{fullDateF}</p>
                                                {
                                                    isDateRoute ? <div className='calender-holder-dashboard' ref={dateRouteRef}>
                                                        
                                                        <Calendar value={moment(routeDate)?._d} inline onChange={(e) => {
                                                            setRouteDate(e)
                                                            handleRouteDate(e)
                                                        }} unstyled={false} />
                                                    </div> : null
                                                }
                                            </div>
                                            <svg onClick={handleNextDate} width="6" height="11" viewBox="0 0 6 11" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ cursor: 'pointer' }}>
                                                <path d="M0.807692 0L0 0.916667L4.26923 5.5L0 10.0833L0.807692 11L6 5.5L0.807692 0Z" fill="#FF8402" />
                                            </svg>
                                        </div> : null
                                    }
                                </div>

                                {   
                                    (isHolidayStatus !== null && routeS === 'level' && view !== 'day') && 
                                        <div className='dayViewHolidayOrLeave'>
                                            <div className='divtextConetntleave' title={isHolidayStatus?.holidayDescription} style={{background: 'rgba(75, 85, 90, 1)', color: '#fff'}}>
                                                {isHolidayStatus?.holidayTitle.length > 15 ? isHolidayStatus?.holidayTitle.substring(0, 25) + '...' : isHolidayStatus?.holidayTitle}
                                            </div>
                                        </div>
                                }

                                { ((routeS === 'mytask' || routeS === 'level')  && view === 'day')  && (
                                    isHolidayStatus !== null ? (
                                        <div className='dayViewHolidayOrLeave'>
                                            <div className='divtextConetntleave' title={isHolidayStatus?.holidayDescription} style={{background: 'rgba(75, 85, 90, 1)', color: '#fff'}}>
                                                {isHolidayStatus?.holidayTitle.length > 15 ? isHolidayStatus?.holidayTitle.substring(0, 25) + '...' : isHolidayStatus?.holidayTitle}
                                            </div>
                                        </div>
                                    ) : (
                                        <div className='dayViewHolidayOrLeave'>
                                            { ( empIsLeaveStatus === null || empIsLeaveStatus?.leaveFormat === 'HALFDAY1' || empIsLeaveStatus?.leaveFormat === 'HALFDAY2')  && isPresent !== null && 
                                                <div className='isPresentAbsent'style={{background : isPresent === true ? 'rgba(1, 159, 55, 0.15)' : '#fff', marginRight: empIsLeaveStatus!== null ? '18px' : '-52px'}}>
                                                    <div style={{background:  isPresent === true ? 'rgba(1, 159, 55, 1)' : 'rgb(234, 22, 22)'}} className='divLeaveDisc'></div>
                                                    <div style={{color: isPresent === true ?  'rgba(1, 159, 55, 1)' : 'rgb(234, 22, 22)'}}>{isPresent === true ? 'Active' : 'Absent'}</div>
                                                </div>
                                            }
                                            {  empIsLeaveStatus !== null  && 
                                                <div className='divtextConetntleave' style={{background: empIsLeaveStatus.leaveFormat === 'FULLDAY' ?  '#fff' : 'rgba(232, 226, 243, 1)'}}>
                                                    <div style={{background: empIsLeaveStatus.leaveFormat === 'FULLDAY' ? 'rgba(234, 22, 22, 1)' : 'rgba(98, 63, 173, 1)'}} className='divLeaveDisc'></div>
                                                    <div style={{color: empIsLeaveStatus.leaveFormat === 'FULLDAY' ?  'rgba(234, 22, 22, 1)' : 'rgba(38, 50, 56, 1)'}}>{covertStringFormat(empIsLeaveStatus?.leaveFormat)}</div>
                                                </div>
                                            }
                                        </div>
                                    )
                                )}


                                {
                                    routeS !== "info" ? <div className='dashboard-features'>
                                        <div className='dashboard-features-container'>
                                            {
                                                (routeS === "mytask" || routeS === 'level') && view === 'day' ?
                                                    <div className='search'>
                                                        <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path fillRule="evenodd" clipRule="evenodd" d="M2.77005 0.341571C3.31446 0.116066 3.89796 0 4.48724 0C5.07651 0 5.66001 0.116066 6.20443 0.341571C6.74885 0.567075 7.24351 0.897603 7.66019 1.31428C8.07687 1.73096 8.4074 2.22563 8.63291 2.77005C8.85841 3.31446 8.97447 3.89797 8.97447 4.48724C8.97447 5.07651 8.85841 5.66001 8.6329 6.20443C8.45661 6.63004 8.21613 7.02525 7.92048 7.37656L9.88735 9.34343C10.0375 9.49363 10.0375 9.73715 9.88735 9.88735C9.73715 10.0375 9.49363 10.0375 9.34343 9.88735L7.37656 7.92049C6.5709 8.59857 5.54845 8.97447 4.48724 8.97447C3.29715 8.97447 2.1558 8.50171 1.31428 7.66019C0.472761 6.81867 0 5.67733 0 4.48724C0 3.29715 0.472761 2.1558 1.31428 1.31428C1.73096 0.897603 2.22563 0.567075 2.77005 0.341571ZM4.48724 0.769223C3.99898 0.769223 3.5155 0.865392 3.06441 1.05224C2.61332 1.23909 2.20345 1.51295 1.8582 1.8582C1.16094 2.55547 0.769223 3.50116 0.769223 4.48724C0.769223 5.47332 1.16094 6.41901 1.8582 7.11627C2.55547 7.81353 3.50116 8.20525 4.48724 8.20525C5.47332 8.20525 6.41901 7.81353 7.11627 7.11627C7.46152 6.77102 7.73539 6.36115 7.92224 5.91006C8.10908 5.45897 8.20525 4.97549 8.20525 4.48724C8.20525 3.99898 8.10908 3.5155 7.92224 3.06441C7.73539 2.61332 7.46152 2.20345 7.11627 1.8582C6.77102 1.51295 6.36115 1.23909 5.91006 1.05224C5.45897 0.865392 4.97549 0.769223 4.48724 0.769223Z" fill="#263238" />
                                                        </svg>
                                                        <input type='search' placeholder='Search task name' alt='/' onChange={(e) => debouncedSearchDay(e.target.value)} />
                                                    </div> : null
                                            }
                                            {
                                                (routeS === "mytask" || routeS === "level") && view === 'month' ?
                                                    <div className='search'>
                                                        <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path fillRule="evenodd" clipRule="evenodd" d="M2.77005 0.341571C3.31446 0.116066 3.89796 0 4.48724 0C5.07651 0 5.66001 0.116066 6.20443 0.341571C6.74885 0.567075 7.24351 0.897603 7.66019 1.31428C8.07687 1.73096 8.4074 2.22563 8.63291 2.77005C8.85841 3.31446 8.97447 3.89797 8.97447 4.48724C8.97447 5.07651 8.85841 5.66001 8.6329 6.20443C8.45661 6.63004 8.21613 7.02525 7.92048 7.37656L9.88735 9.34343C10.0375 9.49363 10.0375 9.73715 9.88735 9.88735C9.73715 10.0375 9.49363 10.0375 9.34343 9.88735L7.37656 7.92049C6.5709 8.59857 5.54845 8.97447 4.48724 8.97447C3.29715 8.97447 2.1558 8.50171 1.31428 7.66019C0.472761 6.81867 0 5.67733 0 4.48724C0 3.29715 0.472761 2.1558 1.31428 1.31428C1.73096 0.897603 2.22563 0.567075 2.77005 0.341571ZM4.48724 0.769223C3.99898 0.769223 3.5155 0.865392 3.06441 1.05224C2.61332 1.23909 2.20345 1.51295 1.8582 1.8582C1.16094 2.55547 0.769223 3.50116 0.769223 4.48724C0.769223 5.47332 1.16094 6.41901 1.8582 7.11627C2.55547 7.81353 3.50116 8.20525 4.48724 8.20525C5.47332 8.20525 6.41901 7.81353 7.11627 7.11627C7.46152 6.77102 7.73539 6.36115 7.92224 5.91006C8.10908 5.45897 8.20525 4.97549 8.20525 4.48724C8.20525 3.99898 8.10908 3.5155 7.92224 3.06441C7.73539 2.61332 7.46152 2.20345 7.11627 1.8582C6.77102 1.51295 6.36115 1.23909 5.91006 1.05224C5.45897 0.865392 4.97549 0.769223 4.48724 0.769223Z" fill="#263238" />
                                                        </svg>
                                                        <input type='search' placeholder='Search task name' alt='/' onChange={(e) => debouncedSearchMonth(e.target.value)} />
                                                    </div> : null
                                            }
                                            {
                                                (routeS === "mytask" || routeS === 'level') && view === 'week' ?
                                                    <div className='search'>
                                                        <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path fillRule="evenodd" clipRule="evenodd" d="M2.77005 0.341571C3.31446 0.116066 3.89796 0 4.48724 0C5.07651 0 5.66001 0.116066 6.20443 0.341571C6.74885 0.567075 7.24351 0.897603 7.66019 1.31428C8.07687 1.73096 8.4074 2.22563 8.63291 2.77005C8.85841 3.31446 8.97447 3.89797 8.97447 4.48724C8.97447 5.07651 8.85841 5.66001 8.6329 6.20443C8.45661 6.63004 8.21613 7.02525 7.92048 7.37656L9.88735 9.34343C10.0375 9.49363 10.0375 9.73715 9.88735 9.88735C9.73715 10.0375 9.49363 10.0375 9.34343 9.88735L7.37656 7.92049C6.5709 8.59857 5.54845 8.97447 4.48724 8.97447C3.29715 8.97447 2.1558 8.50171 1.31428 7.66019C0.472761 6.81867 0 5.67733 0 4.48724C0 3.29715 0.472761 2.1558 1.31428 1.31428C1.73096 0.897603 2.22563 0.567075 2.77005 0.341571ZM4.48724 0.769223C3.99898 0.769223 3.5155 0.865392 3.06441 1.05224C2.61332 1.23909 2.20345 1.51295 1.8582 1.8582C1.16094 2.55547 0.769223 3.50116 0.769223 4.48724C0.769223 5.47332 1.16094 6.41901 1.8582 7.11627C2.55547 7.81353 3.50116 8.20525 4.48724 8.20525C5.47332 8.20525 6.41901 7.81353 7.11627 7.11627C7.46152 6.77102 7.73539 6.36115 7.92224 5.91006C8.10908 5.45897 8.20525 4.97549 8.20525 4.48724C8.20525 3.99898 8.10908 3.5155 7.92224 3.06441C7.73539 2.61332 7.46152 2.20345 7.11627 1.8582C6.77102 1.51295 6.36115 1.23909 5.91006 1.05224C5.45897 0.865392 4.97549 0.769223 4.48724 0.769223Z" fill="#263238" />
                                                        </svg>
                                                        <input type='search' placeholder='Search task name' alt='/' onChange={(e) => debouncedSearchWeek(e.target.value)} />
                                                    </div> : null
                                            }
                                            {
                                                routeS === "level" && view === 'level' ?
                                                    <div className='search'>
                                                        <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path fillRule="evenodd" clipRule="evenodd" d="M2.77005 0.341571C3.31446 0.116066 3.89796 0 4.48724 0C5.07651 0 5.66001 0.116066 6.20443 0.341571C6.74885 0.567075 7.24351 0.897603 7.66019 1.31428C8.07687 1.73096 8.4074 2.22563 8.63291 2.77005C8.85841 3.31446 8.97447 3.89797 8.97447 4.48724C8.97447 5.07651 8.85841 5.66001 8.6329 6.20443C8.45661 6.63004 8.21613 7.02525 7.92048 7.37656L9.88735 9.34343C10.0375 9.49363 10.0375 9.73715 9.88735 9.88735C9.73715 10.0375 9.49363 10.0375 9.34343 9.88735L7.37656 7.92049C6.5709 8.59857 5.54845 8.97447 4.48724 8.97447C3.29715 8.97447 2.1558 8.50171 1.31428 7.66019C0.472761 6.81867 0 5.67733 0 4.48724C0 3.29715 0.472761 2.1558 1.31428 1.31428C1.73096 0.897603 2.22563 0.567075 2.77005 0.341571ZM4.48724 0.769223C3.99898 0.769223 3.5155 0.865392 3.06441 1.05224C2.61332 1.23909 2.20345 1.51295 1.8582 1.8582C1.16094 2.55547 0.769223 3.50116 0.769223 4.48724C0.769223 5.47332 1.16094 6.41901 1.8582 7.11627C2.55547 7.81353 3.50116 8.20525 4.48724 8.20525C5.47332 8.20525 6.41901 7.81353 7.11627 7.11627C7.46152 6.77102 7.73539 6.36115 7.92224 5.91006C8.10908 5.45897 8.20525 4.97549 8.20525 4.48724C8.20525 3.99898 8.10908 3.5155 7.92224 3.06441C7.73539 2.61332 7.46152 2.20345 7.11627 1.8582C6.77102 1.51295 6.36115 1.23909 5.91006 1.05224C5.45897 0.865392 4.97549 0.769223 4.48724 0.769223Z" fill="#263238" />
                                                        </svg>
                                                        <input type='search' placeholder='Search employee name...' alt='/' onChange={(e) => debouncedSearchLevel(e.target.value)} />
                                                    </div> : null
                                            }
                                            {
                                                routeS === "employee" ?
                                                    <div className='search'>
                                                        <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path fillRule="evenodd" clipRule="evenodd" d="M2.77005 0.341571C3.31446 0.116066 3.89796 0 4.48724 0C5.07651 0 5.66001 0.116066 6.20443 0.341571C6.74885 0.567075 7.24351 0.897603 7.66019 1.31428C8.07687 1.73096 8.4074 2.22563 8.63291 2.77005C8.85841 3.31446 8.97447 3.89797 8.97447 4.48724C8.97447 5.07651 8.85841 5.66001 8.6329 6.20443C8.45661 6.63004 8.21613 7.02525 7.92048 7.37656L9.88735 9.34343C10.0375 9.49363 10.0375 9.73715 9.88735 9.88735C9.73715 10.0375 9.49363 10.0375 9.34343 9.88735L7.37656 7.92049C6.5709 8.59857 5.54845 8.97447 4.48724 8.97447C3.29715 8.97447 2.1558 8.50171 1.31428 7.66019C0.472761 6.81867 0 5.67733 0 4.48724C0 3.29715 0.472761 2.1558 1.31428 1.31428C1.73096 0.897603 2.22563 0.567075 2.77005 0.341571ZM4.48724 0.769223C3.99898 0.769223 3.5155 0.865392 3.06441 1.05224C2.61332 1.23909 2.20345 1.51295 1.8582 1.8582C1.16094 2.55547 0.769223 3.50116 0.769223 4.48724C0.769223 5.47332 1.16094 6.41901 1.8582 7.11627C2.55547 7.81353 3.50116 8.20525 4.48724 8.20525C5.47332 8.20525 6.41901 7.81353 7.11627 7.11627C7.46152 6.77102 7.73539 6.36115 7.92224 5.91006C8.10908 5.45897 8.20525 4.97549 8.20525 4.48724C8.20525 3.99898 8.10908 3.5155 7.92224 3.06441C7.73539 2.61332 7.46152 2.20345 7.11627 1.8582C6.77102 1.51295 6.36115 1.23909 5.91006 1.05224C5.45897 0.865392 4.97549 0.769223 4.48724 0.769223Z" fill="#263238" />
                                                        </svg>
                                                        <input type='search' placeholder='Search employee name...' alt='/' onChange={(e) => debouncedSearchEmployee(e.target.value)} />
                                                    </div> : null
                                            }
                                         
                                            {
                                                routeS === "employee" ?
                                                    (<div className='addTask-btn' onClick={() => {
                                                        dispatch(setAddEmp(true))
                                                        handleEmployeeList()
                                                    }}>Add Employees</div>) :
                                                    routeS === "projects" || routeS === 'requests' || routeS === "analytics" ? (selfInfo.role && (selfInfo.role[0].roleLevel === 1 || selfInfo.role[0].roleLevel === 2) && routeS !== 'requests' ? (routeS === "analytics" ? null : <div className='addTask-btn' onClick={() => { dispatch(setAddProject(true)) }}>{'Add Project'}</div>) : null) :
                                                        (routeS !== 'settings' ? (<button className='addTask-btn' onClick={() => {
                                                            const splitFullDate = fullDateF.split(" ")
                                                            const mNumber = getMonthNumber(splitFullDate[2])
                                                            const postDate = splitFullDate[3] + "-" + (mNumber?.length > 1 ? mNumber : '0' + mNumber) + "-" + splitFullDate[1]
                                                            if (view === "day") {
                                                                if (!isDateLessThanCurrent(postDate)) {
                                                                    toast.error("Task cannot be added before joining date")
                                                                    return
                                                                }
                                                                dispatch(setDate(postDate))
                                                            } else {
                                                                dispatch(setDate(''))
                                                            }
                                                            dispatch(setDispatchAllTask(dispatchAllTask?.filter(obj => obj?.empId !== null)))
                                                            dispatch(setAddTask(true))
                                                        }}>{
                                                                routeS === "mytask" ? "Add Task" : "New Task"
                                                            }</button>) : null)
                                            }
                                          

                                            {routeS === 'requests' &&
                                                <select className='filtersForRequests' onChange={(event) => {
                                                    const selectedValue = event.target.value;
                                                    const stringHeaders = window.localStorage.getItem('myHeaders');
                                                    const storedHeaders = JSON.parse(stringHeaders);
                                                    if (selectedValue === "Pending") {
                                                        axios.get(`${url}task/req/get/all?empId=${selfInfo.empId}&status=Pending`, { headers: storedHeaders })
                                                            .then(response => {
                                                                setRequestObject(response.data)
                                                            })
                                                            .catch(error => {});
                                                    } else if (selectedValue === "Accepted") {

                                                        axios.get(`${url}task/req/get/all?empId=${selfInfo.empId}&status=Accepted`, { headers: storedHeaders })
                                                            .then(response => {
                                                                setRequestObject(response.data)
                                                            })
                                                    } else if (selectedValue === "Rejected") {

                                                        axios.get(`${url}task/req/get/all?empId=${selfInfo.empId}&status=Rejected`, { headers: storedHeaders })
                                                            .then(response => {
                                                                setRequestObject(response.data)
                                                            })
                                                    }
                                                }}>
                                                    <option>Pending</option>
                                                    <option>Accepted</option>
                                                    <option>Rejected</option>
                                                </select>
                                            }

                                            {routeS === "analytics" ?
                                                <div className='analytics-parameters'>
                                                    <div className='analytics-date-range-container'>
                                                        {/* <div className='analytics-date-range' style={{ background: selectedBtn === 'range' ? "rgba(255, 246, 223, 1)" : null, borderLeft: selectedBtn === 'range' ? "1px solid rgba(255, 132, 2, 1)" : null }}>22  Nov  2023  -  15  Dec  2023</div> */}
                                                        <DatePicker
                                                            selectsRange
                                                            startDate={startDate}
                                                            endDate={endDate}
                                                            onChange={(update) => {
                                                                const [start, end] = update;
                                                                setStartDate(start);
                                                                setEndDate(end);
                                                                handleRangeAnalytics(start, end)
                                                            }}
                                                            placeholderText='Start Date - End Date'
                                                            startDatePlaceholderText="Start Date"
                                                            endDatePlaceholderText="End Date"
                                                            dateFormat="MM/dd/yyyy"
                                                            withPortal
                                                        />
                                                    </div>
                                                    <div className='analytics-month-range-container'>
                                                        <div className='analytics-month-range' style={{ background: selectedBtn === 'month' ? "rgba(255, 246, 223, 1)" : null, borderLeft: selectedBtn === 'month' ? "1px solid rgba(255, 132, 2, 1)" : null }} onClick={() => setIsMonthAnalytics(true)}>{monthBtn}</div>
                                                        {isMonthAnalytics ?
                                                            <div className='calender-holder-dashboard' ref={mothDateRouteWrapper}>
                                                                <RouteCalender value={analyticsMonth} inline view='month' unstyled={false} onChange={(e) => handleMonthAnalytics(e)} />
                                                            </div> : null
                                                        }
                                                    </div>

                                                    <div className='analytics-month-range-container'>
                                                        <div className='analytics-month-range' style={{ background: selectedBtn === 'quarter' ? "rgba(255, 246, 223, 1)" : null, borderLeft: selectedBtn === 'quarter' ? "1px solid rgba(255, 132, 2, 1)" : null }} onClick={() => setIsQuarterAnalytics(true)}>{selectedQuarter}</div>
                                                        {isQuaterAnylytics ? <div className='quater-calender' ref={quaterRouteRef}>{!isQuaterYear ? <div className='quater-calender-navigation'>
                                                            <div className='quater-year-navigation' onClick={() => setIsQuaterYear(true)}>{quaterYear}</div>
                                                            <div className='quater-navigaters'>
                                                                <svg onClick={() => {
                                                                    const date = moment(`${quaterYear}-01-01`)
                                                                    const newDate = moment(date._d).subtract(1, 'year').toDate();
                                                                    setQuaterYear(newDate.getFullYear())
                                                                }} width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <path d="M12.8679 6.42566C13.1809 6.73037 13.1722 7.23589 12.8489 7.52966C12.5539 7.79773 12.1017 7.79146 11.8142 7.51532L6.72262 2.62448L1.63106 7.51532C1.34358 7.79146 0.891329 7.79773 0.596309 7.52966C0.273013 7.23589 0.264311 6.73037 0.577304 6.42566L6.72262 0.442833L12.8679 6.42566Z" fill="#263238" fill-opacity="0.8" />
                                                                </svg>
                                                                <svg onClick={() => {
                                                                    const date = moment(`${quaterYear}-01-01`)
                                                                    const newDate = moment(date._d).add(1, 'year').toDate();
                                                                    setQuaterYear(newDate.getFullYear())
                                                                }} width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <path d="M13.2 2.02356C13.513 1.71885 13.5043 1.21332 13.181 0.919561C12.8859 0.65149 12.4337 0.657757 12.1462 0.933902L7.05465 5.82474L1.96309 0.933901C1.67561 0.657757 1.22336 0.65149 0.92834 0.919561C0.605044 1.21332 0.596342 1.71885 0.909335 2.02356L7.05465 8.00639L13.2 2.02356Z" fill="#263238" fill-opacity="0.8" />
                                                                </svg>
                                                            </div>
                                                        </div> : null

                                                        }
                                                            {isQuaterYear ?
                                                                <RouteCalender value={moment(`${quaterYear}-01-01`)._d} inline view='year' unstyled={false} onChange={(e) => {
                                                                    const year = moment(e.target.value).year();
                                                                    setQuaterYear(year)
                                                                    setIsQuaterYear(false)
                                                                }} /> : <div className='quater-name-container'>
                                                                    <div className='quater-names' onClick={() => handleQuarterData(`${quaterYear}-01-01`, `${quaterYear}-03-31`, "Quarter1")}>Quarter 1 (Jan, Feb, Mar)</div>
                                                                    <div className='quater-names' onClick={() => handleQuarterData(`${quaterYear}-04-01`, `${quaterYear}-06-30`, "Quarter2")}>Quarter 2 (Apr, May, Jun)</div>
                                                                    <div className='quater-names' onClick={() => handleQuarterData(`${quaterYear}-07-01`, `${quaterYear}-09-30`, "Quarter3")}>Quarter 3 (Jul, Aug, Sep)</div>
                                                                    <div className='quater-names' onClick={() => handleQuarterData(`${quaterYear}-10-01`, `${quaterYear}-12-31`, "Quarter4")}>Quarter 4 (Oct, Nov, Dec)</div>
                                                                </div>
                                                            }

                                                        </div> : null
                                                        }
                                                    </div>
                                                    <div className='analytics-month-range-container' onClick={() => setIsYearAnalytics(true)}>
                                                        <div className='analytics-month-range' style={{ background: selectedBtn === 'year' ? "rgba(255, 246, 223, 1)" : null, borderLeft: selectedBtn === 'year' ? "1px solid rgba(255, 132, 2, 1)" : null }}>{yearBtn}</div>
                                                        {isYearAnalytics ?
                                                            <div className='calender-holder-dashboard' ref={yearDateRouteWrapper}>
                                                                <RouteCalender value={analyticsMonth} inline view='year' unstyled={false} onChange={(e) => handleYearAnalytics(e)} />
                                                            </div> : null
                                                        }
                                                    </div>
                                                    <div className='analytics-month-range-container'>
                                                        <div className='analytics-month-range' style={{ background: selectedBtn === 'overall' ? "rgba(255, 246, 223, 1)" : null, borderLeft: selectedBtn === 'overall' ? "1px solid rgba(255, 132, 2, 1)" : null }} onClick={handleOverallAnalytics}>Overall</div>
                                                    </div>
                                                </div> : null

                                            }

                                        </div>
                                    </div> : null
                                }

                            </div>
                            : null}
                        <div className='dashboard-container' style={{ boxShadow: routeS === 'projects' || routeS === 'requests' || routeS === 'closureReport' || routeS === 'meettingsCards' || routeS === 'projectAllTask' || routeS === 'leaveCalenderView' || routeS === 'scannerView' || routeS === 'attendenceMonthView' || routeS === 'myLeaveStatus' || routeS === 'attendMusteredView' ? 'none' : null, background: routeS === 'closureReport' || routeS === 'projectAllTask' || routeS === 'attendMusteredView' ? 'none' : '#fff', height: routeS === 'requests' || routeS === 'projectAllTask' || routeS === 'leaveCalenderView' || routeS === 'scannerView' || routeS === 'attendenceMonthView' || routeS === 'myLeaveStatus' || routeS === 'attendMusteredView' ? "96%" : null }} >
                            {
                                routeS === "mytask" ? (
                                    <CalenderView props={monthData} />
                                ) : routeS === "employee" ? (
                                    <AddEmployeeHome />
                                ) : routeS === "level" ? (
                                    <Level />
                                ) : routeS === 'info' ? (
                                    <Information />
                                ) : routeS === 'projects' ? (
                                    <ProjectSection />
                                ) : routeS === 'requests' ? (
                                    <Request />
                                ) : routeS === 'closureReport' ? (
                                    <ClosureReports />
                                ) : routeS === 'meettingsCards' ? (
                                    <MeetingCards />
                                ) : routeS === 'projectAllTask' ? (
                                    <ProjectTasks />
                                ) : routeS === 'analytics' ? (
                                    <AnalyticsHome />
                                ) : routeS === 'settings' ? (
                                    <Setting />
                                ) : routeS === 'leaveCalenderView' ? (
                                    <LeveCalenderView />
                                ) : routeS === 'leaveDayView' ? (
                                    <LeaveDayView />
                                ) : routeS === 'scannerView' ? (
                                    <Scanner />
                                ) : routeS === 'attendenceMonthView' ? (
                                    <AttendenceMonthView />
                                ) : routeS === 'myLeaveStatus' ? (
                                    <MyLeaveStatus />
                                ) : routeS === 'attendenceDayView' ? (
                                    <AttendenceDayView />
                                ) : routeS === 'attendMusteredView' ? (
                                    <AttendenceMustered />
                                ) : null
                            }
                        </div>
                    </div>
                </div>
            </div>

            {
                addTaskView ? <NewAddTask props={selfData} /> : null
            }
            {
                editForm ? <EditEmpInfo props={selfInfo} /> : null
            }
            {
                empForm ? <EmployeeForm props={selfData} /> : null
            }
            {
                closureMail ? <ClosureMail /> : null
            }
            {
                closureProcedure ? <MailKeyProcedure /> : null
            }
            {
                addProject ? <AddProject props={selfData} /> : null
            }
            {
                phaseView !== "none" && phaseView !== "milestone" && phaseView !== "sprint" ? <AddPhase /> : null
            }
            {
                phaseView !== "none" && phaseView !== "phase" && phaseView !== "sprint" ? <AddMilestone /> : null
            }
            {
                phaseView !== "none" && phaseView !== "phase" && phaseView !== "milestone" ? <AddSprint /> : null
            }
            {
                getLogs ? <LogsView /> : null
            }
            {
                notifications ? <Notification /> : null
            }

            {
                reminderNotify ? <Reminders /> : null
            }
            {
                logout ? <Logout /> : null
            }

            {
                reqDenyPopUp ? <DenyPopUp /> : null
            }

            {
                reAskOption ? <DenyPreAskOptn /> : null
            }
            {
                changePass ? <ChangePass /> : null
            }

            {
                taskDetailFalg ? <TaskDetails /> : null
            }

            {
                updateProjectFlag ? <UpdateProject /> : null
            }

            {
                addHolidayFlag ? <AddHoliday /> : null
            }

            {
                addLeaveFlag ? <AddLeave /> : null
            }

            {
                editeLeaveFlag ? <EditeLeave /> : null
            }

            {
                holidayListFlag ? <HolidayList /> : null
            }

            {
                editeHolidayFlag ? <EditeHoliday /> : null
            }

        </div>
    )
}

export default Dashboard
